import React, { useState, useEffect, useCallback, useRef } from "react";
import "./../App.css";
import "./Home.css";
import { CreateSearchBarWithPlaceHolder, CreateButton } from "./CommonObjects";
import { SetAuditTrail } from "./Reports/AuditTrailReportEmployeeSetup";
import ViewEmployee from "./Personnel/ViewEmployee";
import IntroImg from "../assets/payroll-intro.jpeg";
import axios from "axios";
import { useTable, useSortBy } from "react-table";
import { token, domain, globalTimeFormat } from "./Security";
import { BarChart, Bar, Tooltip, ResponsiveContainer } from "recharts";
import "react-tabs/style/react-tabs.css";
import loadingSpinner from "./../assets/loading.gif";
// icons
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import ImageIcon from "@mui/icons-material/Image";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import SaveIcon from "@mui/icons-material/Save";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ListIcon from "@mui/icons-material/List";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import UpdateIcon from "@mui/icons-material/Update";

//Global Variables -start
var tooltip;

const Home = ({
  user,
  userAccess,
  employeePhoto,
  setEmployeePhoto,
  isHideSideMenu,
}) => {
  console.log(domain);
  // Connect to API
  const [employees, setEmployees] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("name");
  //ViewEmployee
  const [showViewEmployee, setShowViewEmployee] = useState(false);
  const [viewedData, setViewedData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [filteredEmployee, setFilteredEmployee] = useState([]);

  const [loading, setLoading] = useState(true);

  const handleFilter = (value) => {
    const lowercaseValue = value.toLowerCase();
    var res = [];
    setCurrentPage(1);

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }
    setEmployees(res);
  };

  const apiUrl = domain + "/api/Employee";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(apiUrl + "/single-data", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setEmployees(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  const fetchDataFilteredEmployee = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        apiUrl + `/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [apiUrl, user]);

  const fetchDataEmployeeById = useCallback(
    async (id) => {
      try {
        const response = await axios.get(apiUrl + `/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
        return [];
      }
    },
    [apiUrl]
  );

  useEffect(() => {
    fetchData();
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("name");
        break;
      case 1:
        setSearchPlaceholder("employee id");
        break;
      default:
        setSearchPlaceholder("name");
        break;
    }
  }, [fetchData, filterDataIndex]);

  useEffect(() => {
    const _fetchData = async () => {
      try {
        const _filteredEmployee = await fetchDataFilteredEmployee();
        setFilteredEmployee(_filteredEmployee);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the async function
    if (!userAccess?.hasHome) {
      _fetchData();
    }
  }, [userAccess, fetchDataFilteredEmployee]);

  const addHandleClick = () => {
    window.location.pathname = "/addEmployee";
  };
  const viewEmployeeHandleClick = async (data) => {
    setLoading(true);
    const employeeInfo = await fetchDataEmployeeById(data.id);
    setViewedData(employeeInfo);

    setLoading(false);
    setShowViewEmployee(true);
  };
  const closeViewEmployeeHandleClick = () => {
    setShowViewEmployee(false);
    setViewedData([]);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <ShowIntroduction
            filteredEmployee={filteredEmployee}
            setEmployeePhoto={setEmployeePhoto}
            employees={employees}
            user={user}
            userAccess={userAccess}
          />{" "}

          {/* Introduction sect */}
          <div className="homeBody row">
            <div className="employee">
              {userAccess?.hasHome ? (
                <ShowEmployeeInformation
                  employees={employees}
                  handleFilter={handleFilter}
                  setFilterDataIndex={setFilterDataIndex}
                  searchPlaceholder={searchPlaceholder}
                  addHandleClick={addHandleClick}
                  viewEmployeeHandleClick={viewEmployeeHandleClick}
                  loading={loading}
                  userAccessData={userAccess}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              ) : (
                <ShowLatestTransactionRequests
                  user={user}
                  filteredEmployee={filteredEmployee}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {showViewEmployee && (
        <ViewEmployee
          user={user}
          isOpen={showViewEmployee}
          onClose={closeViewEmployeeHandleClick}
          viewedData={viewedData}
          setViewedData={setViewedData}
          fetchData={fetchData}
          employeePhoto={employeePhoto}
          setEmployeePhoto={setEmployeePhoto}
        />
      )}
    </div>
  );
};

function ShowIntroduction({
  filteredEmployee,
  setEmployeePhoto,
  employees,
  user,
  userAccess,
}) {
  const [currentView, setCurrentView] = useState("announcement");
  const [imageSource, setImageSource] = useState([]);
  const announcementRef = useRef(null);
  const memoRef = useRef(null);
  const todayAnnouncementRef = useRef(null);
  const todayMemoRef = useRef(null);

  const [employeeInfo, setEmployeeInfo] = useState([]);
  const [generalInfo, setGeneralInfo] = useState([]);
  const [events, setEvents] = useState([]);
  const [todayAnnouncementEvents, setTodayAnnouncementEvents] = useState([]);
  const [todayMemoEvents, setTodayMemoEvents] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [loadingRequest, setLoadingRequest] = useState(false);

  const [hasGeneralAnnouncement, setHasGeneralAnnouncement] = useState(false);
  const [hasGeneralMemo, setHasGeneralMemo] = useState(false);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [imageSrcModalOpen, setImageSrcModalOpen] = useState("");
  const openImage = (imageSrc) => {
    setIsImageModalOpen(true); // Open image in full view
    setImageSrcModalOpen(imageSrc);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close full image modal
  };

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/General";

  const fetchData = useCallback(async () => {
    await axios
      .get(`${apiUrl}/totals`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setGeneralInfo(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [apiUrl]);
  const fetchDataEmployeeInfo = useCallback(async () => {
    const apiUrl = domain + "/api/Employee";

    await axios
      .get(`${apiUrl}/${user.employeePersonalInformationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setEmployeeInfo(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user]);

  const fetchDataTodayAnnouncementEvents = useCallback(async () => {
    const apiUrl = domain + "/api/Announcement";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      let filteredData = [];
      response.data.forEach((announcement) => {
        const announcementDateFrom = new Date(announcement.dateFrom);
        const announcementDateTo = new Date(announcement.dateTo);
        const thisDate = new Date();

        // Strip time component by setting to midnight
        const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
        const announcementDateFromOnly = new Date(
          announcementDateFrom.setHours(0, 0, 0, 0)
        );
        const announcementDateToOnly = new Date(
          announcementDateTo.setHours(23, 59, 59, 999)
        );

        if (
          thisDateOnly >= announcementDateFromOnly &&
          thisDateOnly <= announcementDateToOnly
        ) {
          filteredData.push(announcement);
        }
      });

      return filteredData;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const fetchDataTodayMemoEvents = useCallback(async () => {
    const apiUrl = domain + "/api/Memo";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      let filteredData = [];
      response.data.forEach((memo) => {
        const memoDateFrom = new Date(memo.dateFrom);
        const memoDateTo = new Date(memo.dateTo);
        const thisDate = new Date();

        // Strip time component by setting to midnight
        const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
        const memoDateFromOnly = new Date(memoDateFrom.setHours(0, 0, 0, 0));
        const memoDateToOnly = new Date(memoDateTo.setHours(23, 59, 59, 999));

        if (
          thisDateOnly >= memoDateFromOnly &&
          thisDateOnly <= memoDateToOnly
        ) {
          filteredData.push(memo);
        }
      });

      return filteredData;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const fetchDataEvents = useCallback(async () => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      const _announcements = await fetchDataTodayAnnouncementEvents();
      const _memos = await fetchDataTodayMemoEvents();

      setTodayAnnouncementEvents(_announcements);
      setTodayMemoEvents(_memos);
      setEvents(response.data); // Set the response data to the state

      const findAnnouncement = response.data.find(
        (event) => event.key === "Announcement"
      );
      const findMemo = response.data.find((event) => event.key === "Memo");

      if (findAnnouncement) {
        setHasGeneralAnnouncement(true);
      } else {
        setHasGeneralAnnouncement(false);
      }

      if (findMemo) {
        setHasGeneralMemo(true);
      } else {
        setHasGeneralMemo(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl, fetchDataTodayAnnouncementEvents, fetchDataTodayMemoEvents]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    fetchDataEmployeeInfo();
  }, [fetchDataEmployeeInfo]);
  useEffect(() => {
    fetchDataEvents();
  }, [fetchDataEvents]);

  useEffect(() => {
    if (employeeInfo && employeeInfo.photo) {
      const binaryData = atob(employeeInfo.photo);

      // Convert the binary data to a Uint8Array
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

      const file = new File([blob], "", { type: "image/jpeg" }); // Provide a filename and MIME type

      setSelectedFile(file);
    }
  }, [employeeInfo, employees, user]);

  const barData = [
    {
      name: "Leave Request",
      amount: generalInfo.totalLeaveRequests,
      fill: "#ff4d4d",
    },
    {
      name: "OT Request",
      amount: generalInfo.totalOTRequests,
      fill: "#47d147",
    },
    {
      name: "Loan Request",
      amount: generalInfo.totalLoanRequests,
      fill: "#1a75ff",
    },
  ];

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const handleUpdate = async (event, file) => {
    const apiUrlUpdate = domain + "/api/Employee";

    event.preventDefault();

    setLoadingRequest(true);

    const now = new Date();

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    let base64String = "";
    let photoToBeSave = "";

    if (file) {
      base64String = await toBase64(file);
      photoToBeSave = base64String.split(",")[1];
    }

    const data = {
      employeeId: employeeInfo.employeeId,
      lastName: employeeInfo.lastName,
      firstName: employeeInfo.firstName,
      middleName: employeeInfo.middleName,
      extensionName: employeeInfo.extensionName,
      fullName: employeeInfo.fullName,
      nickName: employeeInfo.nickName,
      age: employeeInfo.age ? employeeInfo.age : 0,
      dateOfBirth: employeeInfo.dateOfBirth ? employeeInfo.dateOfBirth : null,
      placeOfBirth: employeeInfo.placeOfBirth,
      civilStatus: employeeInfo.civilStatus,
      bloodType: employeeInfo.bloodType,
      height: employeeInfo.height,
      weight: employeeInfo.weight,
      citizenship: employeeInfo.citizenship,
      religion: employeeInfo.religion,
      gender: employeeInfo.gender,
      mobileNumber: employeeInfo.mobileNumber,
      emailAddress: employeeInfo.emailAddress,
      blkLot: employeeInfo.blkLot,
      street: employeeInfo.street,
      barangay: employeeInfo.barangay,
      city: employeeInfo.city,
      postalCode: employeeInfo.postalCode,
      yearsOfStay: employeeInfo.yearsOfStay ? employeeInfo.yearsOfStay : 0,
      photo: photoToBeSave,
      deviceNumber: employeeInfo.deviceNumber,
      employeeInformation: {
        employeePersonalInformationId: employeeInfo.id,
        locationId: employeeInfo.employeeInformation.locationId
          ? employeeInfo.employeeInformation.locationId
          : null,
        dateEmployed: employeeInfo.employeeInformation.dateEmployed
          ? employeeInfo.employeeInformation.dateEmployed
          : null,
        dateRegular: employeeInfo.employeeInformation.dateRegular
          ? employeeInfo.employeeInformation.dateRegular
          : null,
        dateProbationary: employeeInfo.employeeInformation.dateProbationary
          ? employeeInfo.employeeInformation.dateProbationary
          : null,
        dateProjectBase: employeeInfo.employeeInformation.dateProjectBase
          ? employeeInfo.employeeInformation.dateProjectBase
          : null,
        dateContractual: employeeInfo.employeeInformation.dateContractual
          ? employeeInfo.employeeInformation.dateContractual
          : null,
        employmentId: employeeInfo.employeeInformation.employmentId
          ? employeeInfo.employeeInformation.employmentId
          : null,
        departmentId: employeeInfo.employeeInformation.departmentId
          ? employeeInfo.employeeInformation.departmentId
          : null,
        sectionId: employeeInfo.employeeInformation.sectionId
          ? employeeInfo.employeeInformation.sectionId
          : null,
        classificationId: employeeInfo.employeeInformation.classificationId
          ? employeeInfo.employeeInformation.classificationId
          : null,
        payTypeId: employeeInfo.employeeInformation.payTypeId
          ? employeeInfo.employeeInformation.payTypeId
          : null,
        shiftScheduleId: employeeInfo.employeeInformation.shiftScheduleId
          ? employeeInfo.employeeInformation.shiftScheduleId
          : null,
        positionId: employeeInfo.employeeInformation.positionId
          ? employeeInfo.employeeInformation.positionId
          : null,
        companyId: employeeInfo.employeeInformation.companyId
          ? employeeInfo.employeeInformation.companyId
          : null,
        salaryType: employeeInfo.employeeInformation.salaryType
          ? employeeInfo.employeeInformation.salaryType
          : null,
        createdDate: now,
        createdBy: 0,
      },
      employeeReportTo: {
        employeePersonalInformationId: employeeInfo.id,
        reportToId: null,
      },
      employeeAccountInformation: {
        employeePersonalInformationId: employeeInfo.id,
        sss: employeeInfo.employeeAccountInformation.sss,
        tin: employeeInfo.employeeAccountInformation.tin,
        passport: employeeInfo.employeeAccountInformation.passport,
        philhealth: employeeInfo.employeeAccountInformation.philhealth,
        pagibig: employeeInfo.employeeAccountInformation.pagibig,
      },
      employeeEducationAttainments: employeeInfo.employeeEducationAttainments,
      employeeDependents: employeeInfo.employeeDependents,
      employeeFamilyData: employeeInfo.employeeFamilyData,
      employeeEmergencyContacts: employeeInfo.employeeEmergencyContacts,
      employeeLeave: {
        employeePersonalInformationId: employeeInfo.id,
        totalVacation:
          employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalVacation
            ? employeeInfo.employeeLeave.totalVacation
            : 0,
        vacationRemaining:
          employeeInfo.employeeLeave &&
          employeeInfo.employeeLeave.vacationRemaining
            ? employeeInfo.employeeLeave.vacationRemaining
            : 0,
        totalSick:
          employeeInfo.employeeLeave && employeeInfo.employeeLeave.totalSick
            ? employeeInfo.employeeLeave.totalSick
            : 0,
        sickRemaining:
          employeeInfo.employeeLeave && employeeInfo.employeeLeave.sickRemaining
            ? employeeInfo.employeeLeave.sickRemaining
            : 0,
        totalServiceIncentive:
          employeeInfo.employeeLeave &&
          employeeInfo.employeeLeave.totalServiceIncentive
            ? employeeInfo.employeeLeave.totalServiceIncentive
            : 0,
        serviceIncentiveRemaining:
          employeeInfo.employeeLeave &&
          employeeInfo.employeeLeave.serviceIncentiveRemaining
            ? employeeInfo.employeeLeave.serviceIncentiveRemaining
            : 0,
        totalSoloParent:
          employeeInfo.employeeLeave &&
          employeeInfo.employeeLeave.totalSoloParent
            ? employeeInfo.employeeLeave.totalSoloParent
            : 0,
        soloParentRemaining:
          employeeInfo.employeeLeave &&
          employeeInfo.employeeLeave.soloParentRemaining
            ? employeeInfo.employeeLeave.soloParentRemaining
            : 0,
      },
      employeeStatuses: {
        employeePersonalInformationId: employeeInfo.id,
        status:
          employeeInfo.employeeStatuses && employeeInfo.employeeStatuses.status
            ? employeeInfo.employeeStatuses.status
            : null,
      },
    };

    try {
      await axios.put(apiUrlUpdate + `/${employeeInfo.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      await SetAuditTrail({
        setupArea: "Home",
        actionTaken: "update",
        field: "Employee's Photo",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      setShowRequestMessage(true);
      setIsSuccess(true);

      if (data.photo) {
        const binaryData = atob(data.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        setEmployeePhoto(file);
        setSelectedFile(file);
      }

      console.log("Data updated successfully");
    } catch (error) {
      setLoadingRequest(false);
      console.error("There was a problem updating data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Check if the selected file is an image
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);

      handleUpdate(event, file);
    } else {
      // Handle case where non-image file is selected
      alert("Please select an image file.");
    }
  };

  const getGeneralImageSource = useCallback(
    (value) => {
      let imageSrc = [];
      const findEvent = events.find((event) => event.key === value);
      const findAllEvent = events.filter(
        (event) => event.key === "Announcement" || event.key === "Memo"
      );

      if (findEvent) {
        if (findEvent.content) {
          const _imageSrc = "data:image/jpeg;base64," + findEvent.content;

          imageSrc.push(_imageSrc);
        }
      }

      let isThereAnImage = false;

      findAllEvent.forEach((event) => {
        if (event.content) {
          isThereAnImage = true;
        }
      });

      if (!isThereAnImage) {
        imageSrc.push(IntroImg);
      }

      return imageSrc;
    },
    [events]
  );
  const announcementContent = () => {
    const findAnnouncement = events.find(
      (event) => event.key === "Announcement"
    );

    if (findAnnouncement) {
      const formattedDescription = findAnnouncement.description
        .split("\n")
        .map((line, index) => (
          <p key={index} className="mb-2 leading-relaxed">
            {line}
          </p>
        ));

      return (
        <div className="bg-white rounded-2xl p-6 max-w-xl mx-auto border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-500 mb-4">
            📢 Announcement
          </h2>
          <div className="text-gray-500 space-y-2">
            {formattedDescription}
          </div>
        </div>
      );
    }

    return null;
  };

  const memoContent = () => {
    const findMemo = events.find((event) => event.key === "Memo");

    if (findMemo) {
      const formattedDescription = findMemo.description
        .split("\n")
        .map((line, index) => (
          <p key={index} className="mb-2 leading-relaxed">
            {line}
          </p>
        ));

      return (
        <div className="bg-white rounded-2xl p-6 max-w-xl mx-auto border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-500 mb-4">
            📝 Memo
          </h2>
          <div className="text-gray-500 space-y-2">
            {formattedDescription}
          </div>
        </div>
      );
    }

    return null;
  };


  function areDatesEqual(date1, date2) {
    // Create Date objects from the provided date strings or values
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Compare year, month, and day of the two Date objects
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }
  const getImageSource = useCallback(
    (value) => {
      let events = [];
      let imageSrc = [];
      if (value === "TodayAnnouncement") {
        events = todayAnnouncementEvents;
      } else if (value === "TodayMemo") {
        events = todayMemoEvents;
      }

      const findEvent = events.filter((event) =>
        areDatesEqual(event.date, new Date())
      );

      if (findEvent.length > 0) {
        imageSrc = findEvent
          .filter((event) => event.content)
          .map((event) => "data:image/jpeg;base64," + event.content);
      }

      return imageSrc;
    },
    [todayAnnouncementEvents, todayMemoEvents]
  );

  // Announcement modal
  const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
  const [openAnnouncementModals, setOpenAnnouncementModals] = useState([]);
  const [allAnnouncementsClosed, setAllAnnouncementsClosed] = useState(false); // Track if all Announcement modals are closed

  useEffect(() => {
    if (todayAnnouncementEvents.length > 0) {
      setOpenAnnouncementModals(
        Array(todayAnnouncementEvents.length).fill(false)
      );
      setCurrentAnnouncementIndex(0); // Start with the first announcement
      setAllAnnouncementsClosed(false); // Reset when new announcements are loaded
    } else {
      setAllAnnouncementsClosed(true); // If no announcements, set flag to allow memos to show
    }
  }, [todayAnnouncementEvents]);

  useEffect(() => {
    if (todayAnnouncementEvents.length > 0) {
      const newOpenModals = Array(todayAnnouncementEvents.length).fill(false);
      if (
        currentAnnouncementIndex >= 0 &&
        currentAnnouncementIndex < todayAnnouncementEvents.length
      ) {
        newOpenModals[currentAnnouncementIndex] = true; // Open the current modal
      }
      setOpenAnnouncementModals(newOpenModals);
    }
  }, [currentAnnouncementIndex, todayAnnouncementEvents]);

  const handleCloseAnnouncementModal = () => {
    if (currentAnnouncementIndex < todayAnnouncementEvents.length - 1) {
      // Close current modal and open the next one
      const newOpenModals = [...openAnnouncementModals];
      newOpenModals[currentAnnouncementIndex] = false; // Close the current modal
      newOpenModals[currentAnnouncementIndex + 1] = true; // Open the next modal
      setOpenAnnouncementModals(newOpenModals);
      setCurrentAnnouncementIndex(currentAnnouncementIndex + 1);
    } else {
      // All announcements processed, close the last one
      const newOpenModals = [...openAnnouncementModals];
      newOpenModals[currentAnnouncementIndex] = false;
      setOpenAnnouncementModals(newOpenModals);
      setAllAnnouncementsClosed(true); // All announcements are now closed
    }
  };

  // Memo Modal
  const [currentMemoIndex, setCurrentMemoIndex] = useState(0);
  const [openMemoModals, setOpenMemoModals] = useState([]);

  useEffect(() => {
    if (todayMemoEvents.length > 0) {
      setOpenMemoModals(Array(todayMemoEvents.length).fill(false));
      setCurrentMemoIndex(0); // Start with the first memo
    }
  }, [todayMemoEvents, allAnnouncementsClosed]);

  useEffect(() => {
    if (allAnnouncementsClosed && todayMemoEvents.length > 0) {
      const newOpenModals = Array(todayMemoEvents.length).fill(false);
      if (currentMemoIndex >= 0 && currentMemoIndex < todayMemoEvents.length) {
        newOpenModals[currentMemoIndex] = true; // Open the current modal
      }
      setOpenMemoModals(newOpenModals);
    }
  }, [currentMemoIndex, todayMemoEvents, allAnnouncementsClosed]);

  const handleCloseMemoModal = () => {
    if (currentMemoIndex < todayMemoEvents.length - 1) {
      setCurrentMemoIndex(currentMemoIndex + 1); // Move to the next memo
    } else {
      setCurrentMemoIndex(-1); // Close all modals when done
    }
  };

  useEffect(() => {
    if (events.length > 0) {
      const announcement = announcementRef.current;
      const memo = memoRef.current;
      const todayAnnouncement = todayAnnouncementRef.current;
      const todayMemo = todayMemoRef.current;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // console.log('Visible:', entry.target.id);
            setCurrentView(entry.target.id);
          }
        });
      }, observerOptions);

      if (announcement) observer.observe(announcement);
      if (memo) observer.observe(memo);
      if (todayAnnouncement) observer.observe(todayAnnouncement);
      if (todayMemo) observer.observe(todayMemo);

      return () => {
        if (announcement) observer.unobserve(announcement);
        if (memo) observer.unobserve(memo);
        if (todayAnnouncement) observer.unobserve(todayAnnouncement);
        if (todayMemo) observer.unobserve(todayMemo);
      };
    }
  }, [events]);

  useEffect(() => {
    if (events.length > 0) {
      if (currentView === "announcement") {
        setCurrentIndex(0);
        if (getGeneralImageSource("Announcement").length > 0) {
          setImageSource(getGeneralImageSource("Announcement"));
        }
      } else if (currentView === "memo") {
        setCurrentIndex(0);
        if (getGeneralImageSource("Memo").length > 0) {
          setImageSource(getGeneralImageSource("Memo"));
        }
      } else if (currentView === "today-announcement") {
        setCurrentIndex(0);
        if (getImageSource("TodayAnnouncement").length > 0) {
          setImageSource(getImageSource("TodayAnnouncement"));
        }
      } else if (currentView === "today-memo") {
        setCurrentIndex(0);
        if (getImageSource("TodayMemo").length > 0) {
          setImageSource(getImageSource("TodayMemo"));
        }
      }
    }
  }, [currentView, getGeneralImageSource, getImageSource, events]);

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageSource.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + imageSource.length) % imageSource.length
    );
  };

  return (
    <>
      <div className="Introduction row flex flex-col 2xl:flex-row gap-2 w-full">
        <div className="!w-full 2xl:!w-2/3 dashboard row shadow-xl">
          {events.length > 0 ? (
            <>
              <div className="Intro-img">
                {imageSource.length > 0 && (
                  <img
                    className="modal-events-image"
                    src={imageSource[currentIndex]}
                    alt=""
                    onClick={() => openImage(imageSource[currentIndex])}
                  />
                )}
                {imageSource.length > 1 && (
                  <div className="imageButton">
                    <button onClick={handlePrev}>{`<`}</button>
                    <button onClick={handleNext}>{`>`}</button>
                  </div>
                )}
              </div>
              <div className="Intro-content">
                <div className="contentText">
                  <h2 style={{ margin: "10px" }}>
                    {
                      <TypingAnimation
                        wordings={
                          "Welcome Back " +
                          user.employeePersonalInformationFullName
                        }
                      />
                    }
                  </h2>
                  {hasGeneralAnnouncement && (
                    <div
                      id="announcement"
                      ref={announcementRef}
                      // className="events-message"
                    >
                      {announcementContent()}
                    </div>
                  )}
                  {hasGeneralMemo && (
                    <div id="memo" ref={memoRef} /* className="events-message" */>
                      {memoContent()}
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <img src={loadingSpinner} alt="Loading..." />
            </div>
          )}
        </div>
        {userAccess?.hasHome ? (
          <div className="!w-full 2xl:!w-1/3 flex flex-col md:flex-row bg-white shadow-xl rounded-md h-[250px] gap-2">
            {/* Total Employees Section */}
            <div className="flex flex-col items-center justify-center rounded-xl p-2 w-full md:w-1/3">
              <h3 className="text-lg font-semibold text-gray-500 text-center">Total Employees</h3>
              <h1 className="text-4xl font-bold text-customMainColor mt-2">
                {generalInfo.totalEmployees}
              </h1>
            </div>

            {/* Chart Section */}
            <div className="flex flex-col gap-4 w-full md:w-2/3">
              <div className="h-40 w-full">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={barData}>
                    <Tooltip content={<CustomTooltip />} />
                    <Bar
                      dataKey="amount"
                      fill="#00a0fc"
                      radius={[6, 6, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Categories */}
              <div className="flex justify-around text-sm font-medium text-gray-500 gap-2 p-2">
                <div className="px-4 py-2 bg-gray-100 rounded-lg shadow-sm">
                  <b>Leave Request</b>
                </div>
                <div className="px-4 py-2 bg-gray-100 rounded-lg shadow-sm">
                  <b>OT Request</b>
                </div>
                <div className="px-4 py-2 bg-gray-100 rounded-lg shadow-sm">
                  <b>Loan Request</b>
                </div>
              </div>
            </div>
          </div>

        ) : (
          <div className="w-full 2xl:w-1/3 bg-white shadow-lg rounded-md flex flex-col overflow-hidden h-[250px]">
            {/* Header */}
            <div className="flex items-center gap-2 bg-customMainColor text-white px-4 py-3">
              <AssignmentIndIcon className="text-white" />
              <span className="text-lg font-semibold tracking-wide">Your Profile</span>
            </div>

            {/* Profile Section */}
            <div className="flex flex-col md:flex-row p-4 gap-6">
              {filteredEmployee ? (
                <>
                  {/* Employee Photo Upload */}
                  <div className="flex flex-col items-center justify-center text-gray-500 w-full md:w-1/3">
                    <label
                      htmlFor="file-input"
                      className="flex flex-col items-center cursor-pointer"
                    >
                      <img
                        src={
                          selectedFile
                            ? URL.createObjectURL(selectedFile)
                            : "images/sample.jpg"
                        }
                        alt="profile"
                        className="w-28 h-28 object-cover rounded-full shadow-md border border-gray-200"
                      />
                      {!selectedFile && (
                        <span className="mt-2 text-xs text-gray-500">
                          Upload a picture
                        </span>
                      )}
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      className="hidden"
                      onChange={handleFileChange}
                    />
                  </div>

                  {/* Employee Info */}
                  <div className="flex-1 w-full md:w-2/3">
                    <div className="space-y-3 text-gray-600">
                      <p>
                        <span className="font-semibold text-gray-500">Name: </span>
                        {filteredEmployee.fullName}
                      </p>
                      <p>
                        <span className="font-semibold text-gray-500">Department: </span>
                        {filteredEmployee.employeeInformation?.departmentDescription ?? ""}
                      </p>
                      <p>
                        <span className="font-semibold text-gray-500">Position: </span>
                        {filteredEmployee.employeeInformation?.positionDescription ?? ""}
                      </p>
                      <p>
                        <span className="font-semibold text-gray-500">Date Employed: </span>
                        {filteredEmployee.employeeInformation?.dateEmployed
                          ? formatDate(filteredEmployee.employeeInformation.dateEmployed)
                          : ""}
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                // Loading State
                <div className="flex items-center justify-center w-full h-48">
                  <img src={loadingSpinner} alt="Loading..." className="w-8 h-8" />
                </div>
              )}
            </div>
          </div>

        )}
      </div>
      {/* Full Image Modal */}
      {isImageModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal} // Click outside to close
        >
          <img
            src={imageSrcModalOpen}
            alt="Full view"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
      {allAnnouncementsClosed &&
        todayMemoEvents.map((event, index) => (
          <MemoModal
            key={index}
            isOpen={openMemoModals[index]}
            onClose={handleCloseMemoModal}
            content={event.description}
            image={event.content}
          />
        ))}
      {todayAnnouncementEvents.map((event, index) => (
        <AnnouncementModal
          key={index}
          isOpen={openAnnouncementModals[index]}
          onClose={handleCloseAnnouncementModal}
          content={event.description}
          image={event.content}
        />
      ))}
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
function ShowEmployeeInformation({
  currentPage,
  setCurrentPage,
  employees,
  handleFilter,
  setFilterDataIndex,
  searchPlaceholder,
  addHandleClick,
  viewEmployeeHandleClick,
  loading,
  userAccessData,
}) {
  return (
    <div className="EmployeeInfo shadow-xl">
      <div className="EmployeeList">
        <div className="Header">
          <div className="titleContainer row">
            <PeopleAltIcon style={{ padding: "0 10px 0 0" }} />
            <h3>List Of Employee</h3>
          </div>
        </div>
        <div className="employeeTabs">
          <EmployeeTabs
            employees={employees}
            handleFilter={handleFilter}
            setFilterDataIndex={setFilterDataIndex}
            searchPlaceholder={searchPlaceholder}
            addHandleClick={addHandleClick}
            viewEmployeeHandleClick={viewEmployeeHandleClick}
            loading={loading}
            userAccessData={userAccessData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
}
const EmployeeTabs = ({
  currentPage,
  setCurrentPage,
  employees,
  handleFilter,
  setFilterDataIndex,
  searchPlaceholder,
  addHandleClick,
  viewEmployeeHandleClick,
  loading,
  userAccessData,
}) => {
  var header = [
    // "Photo",
    "ID",
    "Full Name",
    "Department",
    "Position",
    "",
  ];
  var accessor = [
    // "avatar",
    "employeeId",
    "fullName",
    "employeeInformation.departmentDescription",
    "employeeInformation.positionDescription",
    "manage",
  ];

  const [sortFilter, setSortFilter] = useState("");
  const [sectionFilter, setSectionFilter] = useState("0");
  const [locationFilter, setLocationFilter] = useState("0");
  const [
    classificationFilterForAdminHRHead,
    setClassificationFilterForAdminHRHead,
  ] = useState("0");
  const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] =
    useState("2");
  const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] =
    useState("4");
  const [employeesInfo, setEmployeesInfo] = useState(employees);
  const [currentClassificationFilter, setCurrentClassificationFilter] =
    useState("");
  const [currentSectionFilter, setCurrentSectionFilter] = useState("");

  useEffect(() => {
    let classificiationFilter = classificationFilterForAdminHRHead;

    if (userAccessData) {
      if (
        userAccessData.description === "Admin" ||
        userAccessData.description === "HR Head" ||
        userAccessData.description === "HR Assistant"
      ) {
        classificiationFilter = classificationFilterForAdminHRHead;
      } else if (userAccessData.description === "HR Assistant2") {
        classificiationFilter = classificationFilterForHRAsst2;
      } else if (userAccessData.description === "HR Assistant3") {
        classificiationFilter = classificationFilterForHRAsst3;
      }
    }

    setCurrentClassificationFilter(classificiationFilter);
    setCurrentSectionFilter(sectionFilter);

    const classified = employees.filter((employee) => {
      return (
        employee.employeeInformation &&
        employee.employeeInformation.classificationId &&
        employee.employeeInformation.classificationId.toString() ===
          classificiationFilter.toString()
      );
    });

    let filteredBySection = classified;

    if (sectionFilter !== "0") {
      filteredBySection = classified.filter((_data) => {
        const foundEmployee = employees.find(
          (_employee) => _employee.employeeId === _data.employeeId
        );

        return (
          foundEmployee.employeeInformation &&
          foundEmployee.employeeInformation.sectionId &&
          foundEmployee.employeeInformation.sectionId.toString() ===
            sectionFilter.toString()
        );
      });
    }

    let finalData = [];

    if (classificiationFilter.toString() === "0") {
      finalData = [...employees]; // Always copy array before sorting

      if (sortFilter === "Name (A to Z)") {
        finalData.sort((a, b) => a.fullName.localeCompare(b.fullName));
      } else if (sortFilter === "Name (Z to A)") {
        finalData.sort((a, b) => b.fullName.localeCompare(a.fullName));
      } else if (sortFilter === "Employee Id (lowest to highest)") {
        finalData.sort(
          (a, b) => parseInt(a.employeeId) - parseInt(b.employeeId)
        );
      } else if (sortFilter === "Employee Id (highest to lowest)") {
        finalData.sort(
          (a, b) => parseInt(b.employeeId) - parseInt(a.employeeId)
        );
      }
    } else {
      finalData = [...filteredBySection]; // Always copy array before sorting

      if (sortFilter === "Name (A to Z)") {
        finalData.sort((a, b) => a.fullName.localeCompare(b.fullName));
      } else if (sortFilter === "Name (Z to A)") {
        finalData.sort((a, b) => b.fullName.localeCompare(a.fullName));
      } else if (sortFilter === "Employee Id (lowest to highest)") {
        finalData.sort(
          (a, b) => parseInt(a.employeeId) - parseInt(b.employeeId)
        );
      } else if (sortFilter === "Employee Id (highest to lowest)") {
        finalData.sort(
          (a, b) => parseInt(b.employeeId) - parseInt(a.employeeId)
        );
      }
    }

    let lastData = finalData;

    if (locationFilter !== "0") {
      lastData = finalData.filter(
        (i) =>
          i.employeeInformation?.locationId?.toString() ===
          locationFilter?.toString()
      );
    }

    if (classificiationFilter !== currentClassificationFilter) {
      setSectionFilter("0");
      setLocationFilter("0");
    }

    if (sectionFilter !== currentSectionFilter) {
      setLocationFilter("0");
    }

    setEmployeesInfo(lastData);
  }, [
    employees,
    userAccessData,
    sortFilter,
    locationFilter,
    currentSectionFilter,
    currentClassificationFilter,
    classificationFilterForAdminHRHead,
    classificationFilterForHRAsst2,
    classificationFilterForHRAsst3,
    sectionFilter,
  ]);

  return (
    <div>
      <div style={{ padding: "0 10px" }}>
        <div className="filters-payroll">
          <span>Filter</span>
          <div
            className="payroll-item-holder info-item-holder row"
            style={{ padding: "0 10px 20px 10px", justifyContent: "normal" }}
          >
            <div className="filter-item-payroll popUp-item info-item column">
              <div className="info-item-label"></div>
              <div className="info-item-input">
                {Filter(setFilterDataIndex)}
              </div>
            </div>
            {userAccessData.length <= 0 && (
              <div className="filter-item-payroll popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationFilterDummy />
                </div>
              </div>
            )}
            {userAccessData &&
              (userAccessData.description === "Admin" ||
                userAccessData.description === "HR Head" ||
                userAccessData.description === "HR Assistant") && (
                <div className="filter-item-payroll popUp-item info-item column">
                  <div className="info-item-label">Classification Type</div>
                  <div className="info-item-input">
                    <ClassificationFilter1
                      classificationId={classificationFilterForAdminHRHead}
                      setClassificationId={
                        setClassificationFilterForAdminHRHead
                      }
                    />
                  </div>
                </div>
              )}
            {userAccessData &&
              userAccessData.description === "HR Assistant2" && (
                <div className="filter-item-payroll popUp-item info-item column">
                  <div className="info-item-label">Classification Type</div>
                  <div className="info-item-input">
                    <ClassificationFilter2
                      classificationId={classificationFilterForHRAsst2}
                      setClassificationId={setClassificationFilterForHRAsst2}
                    />
                  </div>
                </div>
              )}
            {userAccessData &&
              userAccessData.description === "HR Assistant3" && (
                <div className="filter-item-payroll popUp-item info-item column">
                  <div className="info-item-label">Classification Type</div>
                  <div className="info-item-input">
                    <ClassificationFilter3
                      classificationId={classificationFilterForHRAsst3}
                      setClassificationId={setClassificationFilterForHRAsst3}
                    />
                  </div>
                </div>
              )}
            {(classificationFilterForAdminHRHead.toString() === "3" ||
              classificationFilterForHRAsst2.toString() === "3") && (
              <div className="filter-item-payroll popUp-item info-item column">
                <div className="info-item-label">Section</div>
                <div className="info-item-input">
                  <SectionIdSelect
                    sectionId={sectionFilter}
                    setSectionId={setSectionFilter}
                  />
                </div>
              </div>
            )}
            {(((userAccessData?.description === "Admin" ||
              userAccessData?.description === "HR Head" ||
              userAccessData?.description === "HR Assistant") &&
              (classificationFilterForAdminHRHead.toString() === "2" ||
                classificationFilterForAdminHRHead.toString() === "3" ||
                classificationFilterForAdminHRHead.toString() === "4")) ||
              (userAccessData.description === "HR Assistant2" &&
                (classificationFilterForHRAsst2.toString() === "2" ||
                  classificationFilterForHRAsst2.toString() === "3" ||
                  classificationFilterForHRAsst2.toString() === "4")) ||
              (userAccessData.description === "HR Assistant3" &&
                (classificationFilterForHRAsst3.toString() === "2" ||
                  classificationFilterForHRAsst3.toString() === "3" ||
                  classificationFilterForHRAsst3.toString() === "4"))
                || userAccessData?.description === "HR Assistant") && (
              <div className="filter-item-payroll popUp-item info-item column">
                <div className="info-item-label">Location</div>
                <div className="info-item-input">
                  <LocationIdSelect
                    locationId={locationFilter}
                    setLocationId={setLocationFilter}
                  />
                </div>
              </div>
            )}
            <div
              className="filter-item-payroll popUp-item info-item column"
              style={{ display: "none" }}
            >
              <div className="info-item-label">Sort</div>
              <div className="info-item-input">
                {Sort(sortFilter, setSortFilter)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="top-table row">
        <div className="left" style={{ width: "50%" }}>
          {CreateSearchBarWithPlaceHolder(
            "",
            "mainte-search row",
            "mainte-search-icon",
            "mainte-search-input",
            (e) => handleFilter(e.target.value),
            "Search by " + searchPlaceholder,
            SearchIcon
          )}
        </div>
        <div className="right row" style={{ width: "50%" }}>
          <div className={"hidden"}>
            {CreateButton(
              "home-add-employee",
              "add row",
              () => addHandleClick(),
              "ADD EMPLOYEE",
              PeopleAltIcon
            )}
          </div>
          <button className="bg-customGreen hover:bg-customGreenHover text-white rounded-md border-none cursor-pointer h-10 flex flex-row items-center gap-2"
            onClick={addHandleClick}
          >
            <PeopleAltIcon fontSize="small"/> ADD EMPLOYEE
          </button>
        </div>
      </div>
      <div id="container1" className="InfoList container">
        <CreateTable
          dataList={employeesInfo}
          dataHeader={header}
          dataAccessor={accessor}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          editHandleClick={viewEmployeeHandleClick}
        />
        {employeesInfo.length > 0 ? (
          <div></div>
        ) : (
          <div>
            {loading ? (
              <div
                style={{
                  position: "fixed",
                  top: "0",
                  left: "0",
                  width: "100vw",
                  height: "100vh",
                  zIndex: "2000",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  backgroundColor: "#ffffff59",
                }}
              >
                <img src={loadingSpinner} alt="Loading..." />
              </div>
            ) : (
              <div> {/*<p>No records to display</p>*/}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
function ShowLatestTransactionRequests({ user, filteredEmployee }) {
  return (
    <div className="EmployeeInfo">
      <div className="EmployeeList">
        <div className="Header">
          <div className="titleContainer row">
            <StickyNote2Icon style={{ padding: "0 10px 0 0" }} />
            <h3>My Latest Transaction Requests</h3>
          </div>
        </div>
        <div className="employeeTabs">
          <Transactions user={user} filteredEmployee={filteredEmployee} />
        </div>
      </div>
    </div>
  );
}
const Transactions = ({ user, filteredEmployee }) => {
  var header = [
    "Reference No.",
    // "Uploaded Image",
    "Date",
    "Date From",
    "Date To",
    "Request Date",
    "Request",
    // "Type",
    "Track Approvers",
    "Status",
    "",
  ];
  var accessor = [
    "id",
    // "content",
    "date",
    "dateFrom",
    "dateTo",
    "requestDate",
    "requestTypeDescription",
    // "type",
    "trackApprovers",
    "status",
    "manage",
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const [overtimeRequestData, setOvertimeRequestData] = useState([]);
  const [leaveRequestData, setLeaveRequestData] = useState([]);
  const [changeOfScheduleData, setChangeOfScheduleData] = useState([]);
  const [changeLogRequestData, setChangeLogRequestData] = useState([]);
  const [requestType, setRequestType] = useState("");

  const [viewImageData, setViewImageData] = useState("");
  const [showViewImage, setShowViewImage] = useState(false);

  //OT
  const [showViewOTForm, setShowViewOTForm] = useState(false);
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [overtimeType, setOvertimeType] = useState("");
  const [date, setDate] = useState("");
  const [hours, setHours] = useState("");
  const [hasOvertimeAllowance, setHasOvertimeAllowance] = useState(false);
  const [isAboveTwoHoursOvertime, setIsAboveTwoHoursOvertime] = useState(false);
  const [reason, setReason] = useState("");
  const [filesOT, setFilesOT] = useState("");
  //Leave
  const [showViewLeaveForm, setShowViewLeaveForm] = useState(false);
  const [
    employeePersonalInformationFullNameLeave,
    setEmployeePersonalInformationFullNameLeave,
  ] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [dateFromLeave, setDateFromLeave] = useState("");
  const [dateToLeave, setDateToLeave] = useState("");
  const [daysLeave, setDaysLeave] = useState("");
  const [isHalfDayLeave, setIsHalfDayLeave] = useState(false);
  const [reasonLeave, setReasonLeave] = useState("");
  const [filesLeave, setFilesLeave] = useState("");
  //Change Request
  const [showViewChangeScheduleForm, setShowViewChangeScheduleForm] =
    useState(false);
  const [
    employeePersonalInformationFullNameChangeSchedule,
    setEmployeePersonalInformationFullNameChangeSchedule,
  ] = useState("");
  const [dateFromChangeSchedule, setDateFromChangeSchedule] = useState("");
  const [dateToChangeSchedule, setDateToChangeSchedule] = useState("");
  const [shiftScheduleFromId, setShiftScheduleFromId] = useState("");
  const [shiftScheduleToId, setShiftScheduleToId] = useState("");
  const [reasonChangeSchedule, setReasonChangeSchedule] = useState("");
  const [filesChangeSchedule, setFilesChangeSchedule] = useState("");
  //DTR CORRECTION
  const [showViewChangeLogRequestForm, setShowViewChangeLogRequestForm] =
    useState(false);
  const [
    employeePersonalInformationIdChangeLogRequest,
    setEmployeePersonalInformationIdChangeLogRequest,
  ] = useState("");
  const [
    employeePersonalInformationFullNameChangeLogRequest,
    setEmployeePersonalInformationFullNameChangeLogRequest,
  ] = useState("");
  const [timeTypeChangeLogRequest, setTimeTypeChangeLogRequest] = useState("");
  const [dateChangeLogRequest, setDateChangeLogRequest] = useState("");
  const [timeRequestedChangeLogRequest, setTimeRequestedChangeLogRequest] =
    useState("");
  const [statusChangeLogRequest, setStatusChangeLogRequest] = useState("");
  const [reasonChangeLogRequest, setReasonChangeLogRequest] = useState("");
  const [
    reasonForRejectionChangeLogRequest,
    setReasonForRejectionChangeLogRequest,
  ] = useState("");
  const [filesChangeLog, setFilesChangeLog] = useState("");
  const [selectedItinerary, setSelectedItinerary] = useState([]);
  const [itineraryTimeIn, setItineraryTimeIn] = useState("");
  const [itineraryTimeOut, setItineraryTimeOut] = useState("");
  const [itineraryLocation, setItineraryLocation] = useState("");
  const [isItinerayAddState, setIsItinerayAddState] = useState(false);
  const [isItinerayUpdateState, setIsItinerayUpdateState] = useState(false);
  const [isItinerayDeleteState, setIsItinerayDeleteState] = useState(false);

  const [daysRange, setDaysRange] = useState(15);
  const [daysRangeTemp, setDaysRangeTemp] = useState(15);

  const updateDaysRange = () => {
    if (daysRange !== daysRangeTemp) {
      setDaysRange(daysRangeTemp);
    }
  };

  //Offset
  const [showViewOffsetForm, setShowViewOffsetForm] = useState(false);
  const [
    employeePersonalInformationFullNameOffset,
    setEmployeePersonalInformationFullNameOffset,
  ] = useState("");
  const [
    employeePersonalInformationIdOffset,
    setEmployeePersonalInformationIdOffset,
  ] = useState("");
  const [offset_type, setOffset_type] = useState("");
  const [offset_type_current, setOffset_type_current] = useState("");
  const [offset_referenceDate, setOffset_referenceDate] = useState("");
  const [offset_date, setOffset_date] = useState("");
  const [offset_hours, setOffset_hours] = useState(0);
  const [offset_referenceId, setOffset_referenceId] = useState("");
  const [offset_dateFrom, setOffset_dateFrom] = useState("");
  const [offset_dateTo, setOffset_dateTo] = useState("");
  const [offset_days, setOffset_days] = useState(0);
  const [offset_reason, setOffset_reason] = useState("");
  const [filesOffset, setFilesOffset] = useState("");

  useEffect(() => {
    if(offset_type !== offset_type_current){
      setOffset_type_current(offset_type)

      setOffset_referenceDate("");
      setOffset_date("");
      setOffset_hours("");
      setOffset_referenceId("");
      setOffset_dateFrom("");
      setOffset_dateTo("");
      setOffset_days("");
    }
  }, [offset_type, offset_type_current])

  const resetOffsetVariables = () => {
    setOffset_type("");
    setOffset_referenceDate("");
    setOffset_date("");
    setOffset_hours("");
    setOffset_referenceId("");
    setOffset_dateFrom("");
    setOffset_dateTo("");
    setOffset_days("");
    setOffset_reason("");
    setFilesOffset("");
  };

  const [deleteData, setDeleteData] = useState([]);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const [editData, setEditData] = useState([]);
  const [showEditOTForm, setShowEditOTForm] = useState(false);
  const [showEditOffsetForm, setShowEditOffsetForm] = useState(false);
  const [showEditLeaveForm, setShowEditLeaveForm] = useState(false);
  const [showEditChangeOfScheduleForm, setShowEditChangeOfScheduleForm] =
    useState(false);
  const [showEditChangeLogForm, setShowEditChangeLogForm] = useState(false);

  const apiUrl = domain + "/api/TransactionRequest";
  const overTimeApiUrl = domain + "/api/OvertimeRequest";
  const leaveTimeApiUrl = domain + "/api/LeaveRequest";
  const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
  const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
  const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const [approverData, setApproverData] = useState(null);
  const fetchDataApproverData = useCallback(async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        `${apiUrl}/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }, [user]);
  const fetchDataLocationApproverData = useCallback(async () => {
    const apiUrl = domain + "/api/LocationApproverHierarchy";

    try {
      const response = await axios.get(
        `${apiUrl}/employeePersonalInformationId/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }, [user]);

  const generatePrimaryApprover = () => {
    return (
      <>
        {approverData?.primaryApprover?.primaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover1FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover2FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover3FullName}
          </span>
        )}
        {approverData?.primaryApprover?.primaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.primaryApprover?.primaryApprover4FullName}
          </span>
        )}
      </>
    );
  };
  const generateSecondaryApprover = () => {
    return (
      <>
        {approverData?.secondaryApprover?.secondaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover1FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover2FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover3FullName}
          </span>
        )}
        {approverData?.secondaryApprover?.secondaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.secondaryApprover?.secondaryApprover4FullName}
          </span>
        )}
      </>
    );
  };
  const generateTertiaryApprover = () => {
    return (
      <>
        {approverData?.tertiaryApprover?.tertiaryApprover1Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover1FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover2Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover2FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover3Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover3FullName}
          </span>
        )}
        {approverData?.tertiaryApprover?.tertiaryApprover4Id && (
          <span style={{ margin: "0 10px" }}>
            {approverData?.tertiaryApprover?.tertiaryApprover4FullName}
          </span>
        )}
      </>
    );
  };

  const fetchDataApproverById = useCallback(async (data) => {
    const apiUrlApproverHierarchy = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        apiUrlApproverHierarchy + `/${data.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return []; // Return an empty array in case of error
    }
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    if (!filteredEmployee) {
      return;
    }

    try {
      const response = await axios.get(
        apiUrl +
          `/my-requests/${daysRange}/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      const approverData = await fetchDataApproverById(user);
      const requests = response.data;

      let hasPrimary = false;
      let hasSecondary = false;
      let hasTertiary = false;

      if (approverData.primaryApprover) {
        if (
          approverData.primaryApprover.primaryApprover1Id ||
          approverData.primaryApprover.primaryApprover2Id ||
          approverData.primaryApprover.primaryApprover3Id ||
          approverData.primaryApprover.primaryApprover4Id
        ) {
          hasPrimary = true;
        }
      }

      if (approverData.secondaryApprover) {
        if (
          approverData.secondaryApprover.secondaryApprover1Id ||
          approverData.secondaryApprover.secondaryApprover2Id ||
          approverData.secondaryApprover.secondaryApprover3Id ||
          approverData.secondaryApprover.secondaryApprover4Id
        ) {
          hasSecondary = true;
        }
      }

      if (approverData.tertiaryApprover) {
        if (
          approverData.tertiaryApprover.tertiaryApprover1Id ||
          approverData.tertiaryApprover.tertiaryApprover2Id ||
          approverData.tertiaryApprover.tertiaryApprover3Id ||
          approverData.tertiaryApprover.tertiaryApprover4Id
        ) {
          hasTertiary = true;
        }
      }

      for (let index = 0; index < requests.length; index++) {
        if (requests[index].approval) {
          if (!hasPrimary) {
            delete requests[index].approval.primaryApproverId;
            delete requests[index].approval.primaryApproverFullName;
            delete requests[index].approval.primaryApproverUpdateDate;
            delete requests[index].approval.primaryApproverStatus;
          }

          if (!hasSecondary) {
            delete requests[index].approval.secondaryApproverId;
            delete requests[index].approval.secondaryApproverFullName;
            delete requests[index].approval.secondaryApproverUpdateDate;
            delete requests[index].approval.secondaryApproverStatus;
          }

          if (!hasTertiary) {
            delete requests[index].approval.tertiaryApproverId;
            delete requests[index].approval.tertiaryApproverFullName;
            delete requests[index].approval.tertiaryApproverUpdateDate;
            delete requests[index].approval.tertiaryApproverStatus;
          }
        } else {
          requests[index].approval = {
            primaryApproverId: 0,
            primaryApproverFullName: "",
            primaryApproverUpdateDate: "",
            primaryApproverStatus: "",
            secondaryApproverId: 0,
            secondaryApproverFullName: "",
            secondaryApproverUpdateDate: "",
            secondaryApproverStatus: "",
            tertiaryApproverId: 0,
            tertiaryApproverFullName: "",
            tertiaryApproverUpdateDate: "",
            tertiaryApproverStatus: "",
          };

          if (!hasPrimary) {
            delete requests[index].approval.primaryApproverId;
            delete requests[index].approval.primaryApproverFullName;
            delete requests[index].approval.primaryApproverUpdateDate;
            delete requests[index].approval.primaryApproverStatus;
          }

          if (!hasSecondary) {
            delete requests[index].approval.secondaryApproverId;
            delete requests[index].approval.secondaryApproverFullName;
            delete requests[index].approval.secondaryApproverUpdateDate;
            delete requests[index].approval.secondaryApproverStatus;
          }

          if (!hasTertiary) {
            delete requests[index].approval.tertiaryApproverId;
            delete requests[index].approval.tertiaryApproverFullName;
            delete requests[index].approval.tertiaryApproverUpdateDate;
            delete requests[index].approval.tertiaryApproverStatus;
          }
        }
      }

      let _approverData = await fetchDataApproverData();

      const { primaryApprover, secondaryApprover, tertiaryApprover } =
        _approverData;

      const isPrimaryNull =
        !primaryApprover ||
        (primaryApprover.primaryApprover1Id === null &&
          primaryApprover.primaryApprover2Id === null &&
          primaryApprover.primaryApprover3Id === null &&
          primaryApprover.primaryApprover4Id === null);

      const isSecondaryNull =
        !secondaryApprover ||
        (secondaryApprover.secondaryApprover1Id === null &&
          secondaryApprover.secondaryApprover2Id === null &&
          secondaryApprover.secondaryApprover3Id === null &&
          secondaryApprover.secondaryApprover4Id === null);

      const isTertiaryNull =
        !tertiaryApprover ||
        (tertiaryApprover.tertiaryApprover1Id === null &&
          tertiaryApprover.tertiaryApprover2Id === null &&
          tertiaryApprover.tertiaryApprover3Id === null &&
          tertiaryApprover.tertiaryApprover4Id === null);

      if (isPrimaryNull && isSecondaryNull && isTertiaryNull) {
        const oldData = _approverData;
        const foundData = await fetchDataLocationApproverData();

        console.log("foundData", foundData);

        const newData = {
          employeeId: oldData.employeeId,
          employeePersonalInformationFullName:
            oldData.employeePersonalInformationFullName,
          employeePersonalInformationId: oldData.employeePersonalInformationId,
          primaryApprover: {
            primaryApprover1FullName:
              foundData?.primaryApprovers[0]?.approverFullName ?? null,
            primaryApprover1Id:
              foundData?.primaryApprovers[0]?.approverId ?? null,
            primaryApprover2FullName:
              foundData?.primaryApprovers[1]?.approverFullName ?? null,
            primaryApprover2Id:
              foundData?.primaryApprovers[1]?.approverId ?? null,
            primaryApprover3FullName:
              foundData?.primaryApprovers[2]?.approverFullName ?? null,
            primaryApprover3Id:
              foundData?.primaryApprovers[2]?.approverId ?? null,
            primaryApprover4FullName:
              foundData?.primaryApprovers[3]?.approverFullName,
            primaryApprover4Id:
              foundData?.primaryApprovers[3]?.approverId ?? null,
          },
          secondaryApprover: {
            secondaryApprover1FullName:
              foundData?.secondaryApprovers[0]?.approverFullName ?? null,
            secondaryApprover1Id:
              foundData?.secondaryApprovers[0]?.approverId ?? null,
            secondaryApprover2FullName:
              foundData?.secondaryApprovers[1]?.approverFullName ?? null,
            secondaryApprover2Id:
              foundData?.secondaryApprovers[1]?.approverId ?? null,
            secondaryApprover3FullName:
              foundData?.secondaryApprovers[2]?.approverFullName ?? null,
            secondaryApprover3Id:
              foundData?.secondaryApprovers[2]?.approverId ?? null,
            secondaryApprover4FullName:
              foundData?.secondaryApprovers[3]?.approverFullName,
            secondaryApprover4Id:
              foundData?.secondaryApprovers[3]?.approverId ?? null,
          },
          tertiaryApprover: {
            tertiaryApprover1FullName:
              foundData?.tertiaryApprovers[0]?.approverFullName ?? null,
            tertiaryApprover1Id:
              foundData?.tertiaryApprovers[0]?.approverId ?? null,
            tertiaryApprover2FullName:
              foundData?.tertiaryApprovers[1]?.approverFullName ?? null,
            tertiaryApprover2Id:
              foundData?.tertiaryApprovers[1]?.approverId ?? null,
            tertiaryApprover3FullName:
              foundData?.tertiaryApprovers[2]?.approverFullName ?? null,
            tertiaryApprover3Id:
              foundData?.tertiaryApprovers[2]?.approverId ?? null,
            tertiaryApprover4FullName:
              foundData?.tertiaryApprovers[3]?.approverFullName,
            tertiaryApprover4Id:
              foundData?.tertiaryApprovers[3]?.approverId ?? null,
          },
        };

        _approverData = newData;
      }

      setApproverData(_approverData);

      setTransactions(requests); // Set the response data to the state
      setFilterData(requests); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [
    apiUrl,
    daysRange,
    filteredEmployee,
    user,
    fetchDataApproverById,
    fetchDataApproverData,
    fetchDataLocationApproverData,
  ]);

  const fetchOTRequestData = useCallback(async () => {}, []);
  const fetchLeaveRequestData = useCallback(async () => {}, []);
  const fetchChangeOfScheduleRequestData = useCallback(async () => {}, []);
  const fetchChangeLogRequestData = useCallback(async () => {}, []);

  useEffect(() => {
    fetchData();
    fetchOTRequestData();
    fetchLeaveRequestData();
    fetchChangeOfScheduleRequestData();
    fetchChangeLogRequestData();
  }, [
    fetchData,
    fetchOTRequestData,
    fetchLeaveRequestData,
    fetchChangeOfScheduleRequestData,
    fetchChangeLogRequestData,
  ]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const res = filterData.filter((f) => f.id.toString().startsWith(value));

    setTransactions(res);
  };

  const fetchOTRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(overTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [overTimeApiUrl]
  );
  const fetchLeaveRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(leaveTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [leaveTimeApiUrl]
  );
  const fetchChangeOfScheduleRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeOfScheduleTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeOfScheduleTimeApiUrl]
  );
  const fetchChangeLogRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeLogRequestTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeLogRequestTimeApiUrl]
  );
  const fetchOffsetRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          offsetRequestTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [offsetRequestTimeApiUrl]
  );

  const viewHandleClick = async (data) => {
    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      setShowViewOTForm(true);
      const requestDataWithId = await fetchOTRequest(data);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);
      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      setShowViewLeaveForm(true);
      const requestDataWithId = await fetchLeaveRequest(data);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      setShowViewChangeScheduleForm(true);
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      setShowViewChangeLogRequestForm(true);
      const requestDataWithId = await fetchChangeLogRequest(data);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    if (data.requestTypeDescription === "Offset") {
      setShowViewOffsetForm(true);
      const requestDataWithId = await fetchOffsetRequest(data);
      setEmployeePersonalInformationFullNameOffset(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationIdOffset(
        requestDataWithId.employeePersonalInformationId
      );
      setOffset_type(requestDataWithId.type);
      setOffset_type_current(requestDataWithId.type);
      setOffset_referenceDate(requestDataWithId.referenceDate);
      setOffset_date(requestDataWithId.date);
      setOffset_hours(requestDataWithId.hours);
      setOffset_referenceId(requestDataWithId.referenceId);
      setOffset_dateFrom(requestDataWithId.dateFrom);
      setOffset_dateTo(requestDataWithId.dateTo);
      setOffset_days(requestDataWithId.days);
      setOffset_reason(requestDataWithId.reason);
      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOffset(filesToBeSet);
    }
  };
  const closeViewHandleClick = () => {
    if (requestType === "Overtime Request") {
      setShowViewOTForm(false);
    }

    if (requestType === "Leave Request") {
      setShowViewLeaveForm(false);
    }

    if (requestType === "Change Schedule") {
      setShowViewChangeScheduleForm(false);
    }

    if (requestType === "Change Log Request") {
      setShowViewChangeLogRequestForm(false);
    }

    if (requestType === "Offset") {
      setShowViewOffsetForm(false);
    }
  };

  const [approveMessage, setApproveMessage] = useState(false);
  const [disapproveMessage, setDisapproveMessage] = useState(false);
  const [cancelledMessage, setCancelledMessage] = useState(false);

  function isValidDate(dateString) {
    // Attempt to create a new Date object
    const date = new Date(dateString);

    // Check if the resulting date is valid
    return !isNaN(date.getTime());
  }

  const editHandleClick = async (data) => {
    if (data.status === "Approved") {
      setApproveMessage(true);
      return;
    } else if (data.status === "Disapproved") {
      setDisapproveMessage(true);
      return;
    } else if (data.status === "Cancelled") {
      setCancelledMessage(true);
      return;
    }

    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      setShowEditOTForm(true);
      const requestDataWithId = await fetchOTRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      setShowEditLeaveForm(true);
      const requestDataWithId = await fetchLeaveRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      setShowEditChangeOfScheduleForm(true);
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      setShowEditChangeLogForm(true);
      const requestDataWithId = await fetchChangeLogRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    if (data.requestTypeDescription === "Offset") {
      setShowEditOffsetForm(true);
      const requestDataWithId = await fetchOffsetRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameOffset(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationIdOffset(
        requestDataWithId.employeePersonalInformationId
      );

      setOffset_type(requestDataWithId.type);
      setOffset_type_current(requestDataWithId.type);
      setOffset_referenceDate(requestDataWithId.referenceDate);
      setOffset_date(requestDataWithId.date);
      setOffset_hours(requestDataWithId.hours);
      setOffset_referenceId(requestDataWithId.referenceId);
      setOffset_dateFrom(requestDataWithId.dateFrom);
      setOffset_dateTo(requestDataWithId.dateTo);
      setOffset_days(requestDataWithId.days);
      setOffset_reason(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOffset(filesToBeSet);
    }
  };
  const closeEditHandleClick = () => {
    if (requestType === "Overtime Request") {
      setShowEditOTForm(false);
    }

    if (requestType === "Leave Request") {
      setShowEditLeaveForm(false);
    }

    if (requestType === "Change Schedule") {
      setShowEditChangeOfScheduleForm(false);
    }

    if (requestType === "Change Log Request") {
      setShowEditChangeLogForm(false);

      setItineraryTimeIn("");
      setItineraryTimeOut("");
      setItineraryLocation("");
      setIsItinerayAddState(false);
      setIsItinerayUpdateState(false);
      setIsItinerayDeleteState(false);
    }

    if (requestType === "Offset") {
      setShowEditOffsetForm(false);

      resetOffsetVariables();
    }
  };
  const updateRequest = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const overTimeApiUrl = domain + "/api/OvertimeRequest";
    const leaveTimeApiUrl = domain + "/api/LeaveRequest";
    const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
    const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
    const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

    let data = {};

    var requestUrl = overTimeApiUrl;

    if (requestType === "Leave Request") {
      requestUrl = leaveTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesLeave.length > 0) {
        base64String = await toBase64(filesLeave[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesLeave ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonLeave,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        dateFrom: dateFromLeave,
        dateTo: dateToLeave,
        leaveTypeId: leaveType,
        days: daysLeave,
        isHalfDay: isHalfDayLeave,
      };
    }

    if (requestType === "Change Schedule") {
      requestUrl = changeOfScheduleTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesChangeSchedule.length > 0) {
        base64String = await toBase64(filesChangeSchedule[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesChangeSchedule ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonChangeSchedule,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        dateFrom: dateFromChangeSchedule,
        dateTo: dateToChangeSchedule,
        shiftScheduleFromId: shiftScheduleFromId,
        shiftScheduleToId: shiftScheduleToId,
      };
    }

    if (requestType === "Overtime Request") {
      requestUrl = overTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesOT.length > 0) {
        base64String = await toBase64(filesOT[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesOT ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reason,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        date: date,
        hours: hours,
        overtimeType: overtimeType,
        hasOvertimeAllowance: hasOvertimeAllowance,
        isAboveTwoHoursOvertime: isAboveTwoHoursOvertime,
      };
    }

    if (requestType === "Change Log Request") {
      requestUrl = changeLogRequestTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesChangeLog.length > 0) {
        base64String = await toBase64(filesChangeLog[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesChangeLog ? photoToBeSave : null;

      const _changeLogItineraries = selectedItinerary.map((item) => {
        let _timeIn = item.timeIn;
        let _timeOut = item.timeOut;
        const dateLog = dateChangeLogRequest.split("T")[0];

        if (isValidDate(_timeIn)) {
          _timeIn = item.timeIn && item.timeIn.split("T")[1];
        }

        if (isValidDate(_timeOut)) {
          _timeOut = item.timeOut && item.timeOut.split("T")[1];
        }

        _timeIn = `${dateLog}T${_timeIn}`;
        _timeOut = `${dateLog}T${_timeOut}`;

        return {
          changeLogRequestId: item.changeLogRequestId,
          timeIn: _timeIn, // Replace this with actual date/time if available
          timeOut: _timeOut, // Replace this with actual date/time if available
          location: item.location,
        };
      });

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: reasonChangeLogRequest,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        date: dateChangeLogRequest,
        timeRendered: timeRequestedChangeLogRequest,
        timeType: timeTypeChangeLogRequest,
        changeLogItineraries: _changeLogItineraries,
      };
    }

    if (requestType === "Offset") {
      requestUrl = offsetRequestTimeApiUrl;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      let base64String = "";
      let photoToBeSave = "";

      if (filesOffset.length > 0) {
        base64String = await toBase64(filesOffset[0]);
        photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesOffset ? photoToBeSave : null;

      data = {
        referenceNumber: editData.referenceNumber,
        employeePersonalInformationId: filteredEmployee.id, //temporary
        approverId: editData.approverId,
        requestTypeId: editData.requestTypeId,
        reason: offset_reason,
        reasonForRejection: editData.reasonForRejection,
        status: editData.status,
        dateRequested: editData.dateRequested,
        dateCompleted: editData.dateCompleted,
        content: uploadImage,
        referenceDate: offset_referenceDate ? offset_referenceDate : null,
        date: offset_date ? offset_date : null,
        hours: offset_hours ? offset_hours : 0,
        type: offset_type,
        referenceId: offset_referenceId ? offset_referenceId : null,
        dateFrom: offset_dateFrom ? offset_dateFrom : null,
        dateTo: offset_dateTo ? offset_dateTo : null,
        days: offset_days ? offset_days : null,
      };
    }
    
    console.log('Final bulkData:', JSON.stringify(data, null, 2));

    try {
      await axios.put(requestUrl + `/${editData.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      closeEditHandleClick();

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();
      setEditData([]);

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const deleteHandleClick = (data) => {
    /* if(data.status === "Approved"){
            setApproveMessage(true);
            return;
        } else if(data.status === "Disapproved"){
            setDisapproveMessage(true);
            return;
        } else */ if (data.status === "Cancelled") {
      setCancelledMessage(true);
      return;
    }

    setRequestType(data.requestTypeDescription);
    setDeleteData(data);
    setShowDeleteForm(true);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const cancelRequest = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);

    const overTimeApiUrl = domain + "/api/OvertimeRequest";
    const leaveTimeApiUrl = domain + "/api/LeaveRequest";
    const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
    const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";
    const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

    var requestUrl = overTimeApiUrl;

    if (requestType === "Leave Request") {
      requestUrl = leaveTimeApiUrl;
    }

    if (requestType === "Change Schedule") {
      requestUrl = changeOfScheduleTimeApiUrl;
    }

    if (requestType === "Overtime Request") {
      requestUrl = overTimeApiUrl;
    }

    if (requestType === "Change Log Request") {
      requestUrl = changeLogRequestTimeApiUrl;
    }

    if (requestType === "Offset") {
      requestUrl = offsetRequestTimeApiUrl;
    }

    const data = {
      id: deleteData.id,
      approverId: user.employeePersonalInformationId, //temporary
      status: "Cancelled",
      reasonForRejection: "",
    };

    try {
      await axios.put(requestUrl + "/status", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      setShowDeleteForm(false);

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();
      setDeleteData([]);

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const viewImage = (data) => {
    setViewImageData(data);
    setShowViewImage(true);
  };
  const closeViewImage = () => {
    setShowViewImage(false);
  };

  useEffect(() => {
    if (approveMessage) {
      const timeoutId = setTimeout(() => {
        setApproveMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [approveMessage]);
  useEffect(() => {
    if (disapproveMessage) {
      const timeoutId = setTimeout(() => {
        setDisapproveMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [disapproveMessage]);
  useEffect(() => {
    if (cancelledMessage) {
      const timeoutId = setTimeout(() => {
        setCancelledMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [cancelledMessage]);

  return (
    <div>
      <div className="Header">
        <div className="titleContainer">
          <div classname="row" style={{ margin: "5px 0" }}>
            <span>{`Primary Approver/s: `}</span>
            {generatePrimaryApprover()}
          </div>
          <div classname="row" style={{ margin: "5px 0" }}>
            <span>{`Secondary Approver/s: `}</span>
            {generateSecondaryApprover()}
          </div>
          <div classname="row" style={{ margin: "5px 0" }}>
            <span>{`Tertiary Approver/s: `}</span>
            {generateTertiaryApprover()}
          </div>
        </div>
        <div
          className="filter-item-payroll popUp-item info-item row"
          style={{ alignItems: "center", marginLeft: "25px" }}
        >
          <div className="info-item-label">Days Range: </div>
          <div className="info-item-input" style={{ marginLeft: "5px" }}>
            <input
              id="employeePersonalInformationFullName"
              placeholder="Days Range"
              value={daysRangeTemp}
              onChange={(e) => setDaysRangeTemp(e.target.value)}
              type="number"
            />
          </div>
          <div style={{ marginLeft: "5px" }}>
            <div className={"hidden"}>
              {CreateButton(
                "",
                "update-days-range row",
                updateDaysRange,
                "UPDATE",
                UpdateIcon
              )}
            </div>
            <button className="bg-blue-500 hover:bg-blue-600 text-white rounded-md border-none cursor-pointer h-10 flex flex-row items-center gap-2"
              onClick={updateDaysRange}
            >
              <UpdateIcon fontSize="small"/> UPDATE
            </button>
          </div>
        </div>
      </div>
      <div className="top-table row">
        <div className="left" style={{ width: "50%", display: "none" }}>
          {CreateSearchBarWithPlaceHolder(
            "",
            "mainte-search row",
            "mainte-search-icon",
            "mainte-search-input",
            (e) => handleFilter(e.target.value),
            "Search by transaction id",
            SearchIcon
          )}
        </div>
      </div>

      <div id="container1" className="InfoList container">
        <CreateTableTransaction
          dataList={transactions}
          dataHeader={header}
          dataAccessor={accessor}
          viewHandleClick={viewHandleClick}
          editHandleClick={editHandleClick}
          deleteHandleClick={deleteHandleClick}
          viewImage={viewImage}
          overtimeRequestData={overtimeRequestData}
          leaveRequestData={leaveRequestData}
          changeOfScheduleData={changeOfScheduleData}
          changeLogRequestData={changeLogRequestData}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          //dummy
          setOvertimeRequestData={setOvertimeRequestData}
          setLeaveRequestData={setLeaveRequestData}
          setChangeOfScheduleData={setChangeOfScheduleData}
          setChangeLogRequestData={setChangeLogRequestData}
        />
      </div>
      <ViewOTForm
        isOpen={showViewOTForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setOvertimeType={setOvertimeType}
        setDate={setDate}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></ViewOTForm>
      <ViewLeaveForm
        isOpen={showViewLeaveForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></ViewLeaveForm>
      <ViewChangeScheduleForm
        isOpen={showViewChangeScheduleForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></ViewChangeScheduleForm>
      <ViewChangeLogRequestForm
        isOpen={showViewChangeLogRequestForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        data={selectedItinerary}
        viewImage={viewImage}
      ></ViewChangeLogRequestForm>
      <ViewOffsetForm
        isOpen={showViewOffsetForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationFullName={ employeePersonalInformationFullNameOffset } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffset }
        employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
        referenceDate={offset_referenceDate} setReferenceDate={setOffset_referenceDate}
        date={offset_date} setDate={setOffset_date}
        hours={offset_hours} setHours={setOffset_hours}
        type={offset_type} setType={setOffset_type}
        referenceId={offset_referenceId} setReferenceId={setOffset_referenceId}
        dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
        dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
        days={offset_days} setDays={setOffset_days}
        reason={offset_reason} setReason={setOffset_reason}
        files={filesOffset} setFiles={setFilesOffset}
        viewImage={viewImage}
      ></ViewOffsetForm>
      <EditOTForm
        isOpen={showEditOTForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setOvertimeType={setOvertimeType}
        setHasOvertimeAllowance={setHasOvertimeAllowance}
        setIsAboveTwoHoursOvertime={setIsAboveTwoHoursOvertime}
        setHours={setHours}
        setReason={setReason}
        setDate={setDate}
        handleUpdate={updateRequest}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></EditOTForm>
      <EditLeaveForm
        isOpen={showEditLeaveForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        setDaysLeave={setDaysLeave}
        setIsHalfDayLeave={setIsHalfDayLeave}
        setReasonLeave={setReasonLeave}
        handleUpdate={updateRequest}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></EditLeaveForm>
      <EditChangeScheduleForm
        isOpen={showEditChangeOfScheduleForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        setReasonChangeSchedule={setReasonChangeSchedule}
        handleUpdate={updateRequest}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></EditChangeScheduleForm>
      <EditChangeLogRequestForm
        isOpen={showEditChangeLogForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        handleUpdate={updateRequest}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        data={selectedItinerary}
        setData={setSelectedItinerary}
        itineraryTimeIn={itineraryTimeIn}
        setItineraryTimeIn={setItineraryTimeIn}
        itineraryTimeOut={itineraryTimeOut}
        setItineraryTimeOut={setItineraryTimeOut}
        itineraryLocation={itineraryLocation}
        setItineraryLocation={setItineraryLocation}
        isItinerayAddState={isItinerayAddState}
        setIsItinerayAddState={setIsItinerayAddState}
        isItinerayUpdateState={isItinerayUpdateState}
        setIsItinerayUpdateState={setIsItinerayUpdateState}
        isItinerayDeleteState={isItinerayDeleteState}
        setIsItinerayDeleteState={setIsItinerayDeleteState}
        viewImage={viewImage}
      ></EditChangeLogRequestForm>
      <EditOffsetForm
        user={user}
        isOpen={showEditOffsetForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullName={ employeePersonalInformationFullNameOffset } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffset }
        employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
        referenceDate={offset_referenceDate} setReferenceDate={setOffset_referenceDate}
        date={offset_date} setDate={setOffset_date}
        hours={offset_hours} setHours={setOffset_hours}
        type={offset_type} setType={setOffset_type}
        referenceId={offset_referenceId} setReferenceId={setOffset_referenceId}
        dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
        dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
        days={offset_days} setDays={setOffset_days}
        reason={offset_reason} setReason={setOffset_reason}
        files={filesOffset} setFiles={setFilesOffset}
        handleUpdate={updateRequest}
        viewImage={viewImage}
      ></EditOffsetForm>

      <ClearGeneralForm
        isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={cancelRequest}
      />
      <ViewImage
        isOpen={showViewImage}
        onClose={closeViewImage}
        viewImageData={viewImageData}
      ></ViewImage>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      <GenerateMessage
        form={approveMessage}
        message={"Already approved!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessage
        form={disapproveMessage}
        message={"Already disapproved!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessage
        form={cancelledMessage}
        message={"Already cancelled!"}
        isSuccess={false}
      ></GenerateMessage>
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

function ViewOTForm({
  isOpen,
  onClose,
  employeePersonalInformationFullName,
  employeePersonalInformationId,
  overtimeType,
  date,
  hours,
  hasOvertimeAllowance,
  isAboveTwoHoursOvertime,
  reason,
  setEmployeePersonalInformationFullName,
  setEmployeePersonalInformationId,
  setOvertimeType,
  setDate,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Overtime Type</div>
                <div className="info-item-input">
                  {OvertimeTypeSelect(overtimeType, setOvertimeType, true)}
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput date={date} setDate={setDate} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="hours"
                      placeholder="Hours"
                      value={hours}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={hasOvertimeAllowance}
                      readOnly={true}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      With overtime allowance?
                    </h5>
                  </div>
                </div>
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-above2"
                      className="checkbox"
                      name=""
                      checked={isAboveTwoHoursOvertime}
                      readOnly={true}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      Above two hours overtime?
                    </h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewLeaveForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameLeave,
  leaveType,
  dateFromLeave,
  dateToLeave,
  daysLeave,
  isHalfDayLeave,
  reasonLeave,
  setEmployeePersonalInformationFullNameLeave,
  setLeaveType,
  setDateFromLeave,
  setDateToLeave,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameLeave}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullNameLeave(
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  {LeaveTypeSelect(leaveType, setLeaveType, true)}
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFromLeave} setDate={setDateFromLeave} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateToLeave} setDate={setDateToLeave} isView={true} />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      readOnly
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={daysLeave}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      readOnly
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={isHalfDayLeave}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonLeave}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewChangeScheduleForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeSchedule,
  dateFromChangeSchedule,
  dateToChangeSchedule,
  shiftScheduleFromId,
  shiftScheduleToId,
  reasonChangeSchedule,
  setDateFromChangeSchedule,
  setDateToChangeSchedule,
  setShiftScheduleFromId,
  setShiftScheduleToId,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameChangeSchedule"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameChangeSchedule}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFromChangeSchedule} setDate={setDateFromChangeSchedule} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateToChangeSchedule} setDate={setDateToChangeSchedule} isView={true} />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule From</div>
                  <div className="info-item-input">
                    {ShiftScheduleIdSelect(
                      shiftScheduleFromId,
                      setShiftScheduleFromId,
                      true
                    )}
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule To</div>
                  <div className="info-item-input">
                    {ShiftScheduleIdSelect(
                      shiftScheduleToId,
                      setShiftScheduleToId,
                      true
                    )}
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeSchedule}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewChangeLogRequestForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeLogRequest,
  timeTypeChangeLogRequest,
  dateChangeLogRequest,
  timeRequestedChangeLogRequest,
  reasonChangeLogRequest,
  setTimeTypeChangeLogRequest,
  setDateChangeLogRequest,
  setTimeRequestedChangeLogRequest,
  files,
  setFiles,
  data,
  viewImage,
}) {
  var header = ["Time In", "Time Out", "Location"];
  var accessor = ["timeIn", "timeOut", "location"];

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameChangeSchedule"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationFullNameChangeLogRequest
                      }
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Type</div>
                  <div className="info-item-input">
                    <TimeTypeSelect
                      timeType={timeTypeChangeLogRequest}
                      setTimeType={setTimeTypeChangeLogRequest}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateChangeLogRequest} setDate={setDateChangeLogRequest} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Requested</div>
                  <div className="info-item-input">
                    <TimeInput
                      date={timeRequestedChangeLogRequest}
                      setDate={setTimeRequestedChangeLogRequest}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeLogRequest}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Itinerary</div>
                <div className="info-item-input">
                  <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                  >
                    <CreateTableItinerary
                      dataList={data}
                      dataHeader={header}
                      dataAccessor={accessor}
                    />
                  </div>
                  {data && data.length > 0 ? (
                    <div></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      {/*<p>No records to display</p>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewOffsetForm({
  isOpen,
  onClose,
  employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
  employeePersonalInformationId, setEmployeePersonalInformationId,
  referenceDate, setReferenceDate,
  date, setDate,
  hours, setHours,
  type, setType,
  referenceId, setReferenceId,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  days, setDays,
  reason, setReason,
  files, setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Type</div>
                <div className="info-item-input">
                  <TypeSelect data={type} setData={setType} isView={true}/>
                </div>
              </div>
              {type === "Overtime" &&
              <>
                <div className="info-item-holder row">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Date</div>
                    <div className="info-item-input">
                    <input
                        id="hours"
                        placeholder="Reference Date"
                        value={referenceDate ? referenceDate.split("T")[0] : ""}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date (To Use)</div>
                    <div className="info-item-input">
                    <DateTimeInput date={date} setDate={setDate} isView={true} />
                    </div>
                  </div>
                </div>
                <div className="info-item-holder row">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        id="hours"
                        placeholder="Hours"
                        value={hours}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className="popUp-item info-item column" style={{visibility: "hidden"}}>
                    <div className="info-item-label">Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        id="hours"
                        placeholder="Hours"
                        value={hours}
                        readOnly={true}
                      />
                    </div>
                  </div>
                </div>
              </>
              }
              {type === "Leave" &&
              <>
                <div className="info-item-holder row">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <input
                        id="referenceId"
                        placeholder="Reference Id"
                        value={
                                referenceId
                                  ? `OS-${referenceId
                                      ?.toString()
                                      .padStart(6, "0")}`
                                  : ""}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Days</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        id="days"
                        placeholder="Days"
                        value={days}
                        readOnly={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="info-item-holder row">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date From (To Use)</div>
                    <div className="info-item-input">
                    <DateTimeInput date={dateFrom} setDate={setDateFrom} isView={true} />
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date To (To Use)</div>
                    <div className="info-item-input">
                    <DateTimeInput date={dateTo} setDate={setDateTo} isView={true} />
                    </div>
                  </div>
                </div>
              </>
              }
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditOTForm({
  isOpen,
  onClose,
  employeePersonalInformationFullName,
  employeePersonalInformationId,
  overtimeType,
  date,
  hours,
  hasOvertimeAllowance,
  isAboveTwoHoursOvertime,
  reason,
  setEmployeePersonalInformationFullName,
  setEmployeePersonalInformationId,
  setOvertimeType,
  setHasOvertimeAllowance,
  setReason,
  setIsAboveTwoHoursOvertime,
  setHours,
  setDate,
  handleUpdate,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Overtime Type</div>
                <div className="info-item-input">
                  {OvertimeTypeSelect(overtimeType, setOvertimeType, false)}
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput date={date} setDate={setDate} isView={false} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="hours"
                      placeholder="Hours"
                      value={hours}
                      onChange={(e) => setHours(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={hasOvertimeAllowance}
                      onChange={(e) =>
                        setHasOvertimeAllowance(e.target.checked)
                      }
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      With overtime allowance?
                    </h5>
                  </div>
                </div>
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-above2"
                      className="checkbox"
                      name=""
                      checked={isAboveTwoHoursOvertime}
                      onChange={(e) =>
                        setIsAboveTwoHoursOvertime(e.target.checked)
                      }
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      Above two hours overtime?
                    </h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditLeaveForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameLeave,
  leaveType,
  dateFromLeave,
  dateToLeave,
  daysLeave,
  isHalfDayLeave,
  reasonLeave,
  setEmployeePersonalInformationFullNameLeave,
  setLeaveType,
  setDateFromLeave,
  setDaysLeave,
  setIsHalfDayLeave,
  setReasonLeave,
  setDateToLeave,
  handleUpdate,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameLeave}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullNameLeave(
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  {LeaveTypeSelect(leaveType, setLeaveType, false)}
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFromLeave} setDate={setDateFromLeave} isView={false} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateToLeave} setDate={setDateToLeave} isView={false} />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={daysLeave}
                      onChange={(e) => setDaysLeave(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      onChange={(e) => setIsHalfDayLeave(e.target.checked)}
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={isHalfDayLeave}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonLeave}
                    onChange={(e) => setReasonLeave(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditChangeScheduleForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeSchedule,
  dateFromChangeSchedule,
  dateToChangeSchedule,
  shiftScheduleFromId,
  shiftScheduleToId,
  reasonChangeSchedule,
  setDateFromChangeSchedule,
  setDateToChangeSchedule,
  setShiftScheduleFromId,
  setReasonChangeSchedule,
  setShiftScheduleToId,
  handleUpdate,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameChangeSchedule"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameChangeSchedule}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFromChangeSchedule} setDate={setDateFromChangeSchedule} isView={false} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateToChangeSchedule} setDate={setDateToChangeSchedule} isView={false} />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule From</div>
                  <div className="info-item-input">
                    {ShiftScheduleIdSelect(
                      shiftScheduleFromId,
                      setShiftScheduleFromId,
                      false
                    )}
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule To</div>
                  <div className="info-item-input">
                    {ShiftScheduleIdSelect(
                      shiftScheduleToId,
                      setShiftScheduleToId,
                      false
                    )}
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeSchedule}
                    onChange={(e) => setReasonChangeSchedule(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditChangeLogRequestForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeLogRequest,
  timeTypeChangeLogRequest,
  dateChangeLogRequest,
  timeRequestedChangeLogRequest,
  reasonChangeLogRequest,
  setTimeTypeChangeLogRequest,
  setDateChangeLogRequest,
  setTimeRequestedChangeLogRequest,
  setReasonChangeLogRequest,
  handleUpdate,
  files,
  setFiles,
  itineraryTimeIn,
  setItineraryTimeIn,
  itineraryTimeOut,
  setItineraryTimeOut,
  itineraryLocation,
  setItineraryLocation,
  isItinerayAddState,
  setIsItinerayAddState,
  isItinerayUpdateState,
  setIsItinerayUpdateState,
  isItinerayDeleteState,
  setIsItinerayDeleteState,
  data,
  setData,
  viewImage,
}) {
  var header = ["Time In", "Time Out", "Location", ""];
  var accessor = ["timeIn", "timeOut", "location", "manage"];

  const handleClose = () => {
    onClose();
    setItineraryTimeIn("");
    setItineraryTimeOut("");
    setItineraryLocation("");
    setIsItinerayAddState(false);
    setIsItinerayUpdateState(false);
    setIsItinerayDeleteState(false);
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  const addClick = () => {
    setIsItinerayAddState(true);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameChangeSchedule"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationFullNameChangeLogRequest
                      }
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Type</div>
                  <div className="info-item-input">
                    <TimeTypeSelect
                      timeType={timeTypeChangeLogRequest}
                      setTimeType={setTimeTypeChangeLogRequest}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    {DateInput(
                      dateChangeLogRequest,
                      setDateChangeLogRequest,
                      false
                    )}
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Requested</div>
                  <div className="info-item-input">
                    <TimeInput
                      date={timeRequestedChangeLogRequest}
                      setDate={setTimeRequestedChangeLogRequest}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeLogRequest}
                    onChange={(e) => setReasonChangeLogRequest(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Itinerary</div>
                <div
                  className="transaction-addBtn row"
                  style={{ margin: "10px 0" }}
                >
                  {CreateButton("", "add row", addClick, "ADD", NoteAddIcon)}
                </div>
                <div className="info-item-input">
                  <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                  >
                    <CreateTableItinerary
                      dataList={data}
                      setDataList={setData}
                      dataHeader={header}
                      dataAccessor={accessor}
                      isItinerayAddState={isItinerayAddState}
                      setIsItinerayAddState={setIsItinerayAddState}
                      isItinerayUpdateState={isItinerayUpdateState}
                      setIsItinerayUpdateState={setIsItinerayUpdateState}
                      isItinerayDeleteState={isItinerayDeleteState}
                      setIsItinerayDeleteState={setIsItinerayDeleteState}
                      itineraryTimeIn={itineraryTimeIn}
                      setItineraryTimeIn={setItineraryTimeIn}
                      itineraryTimeOut={itineraryTimeOut}
                      setItineraryTimeOut={setItineraryTimeOut}
                      itineraryLocation={itineraryLocation}
                      setItineraryLocation={setItineraryLocation}
                    />
                  </div>
                  {data && data.length > 0 ? (
                    <div></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      {/*<p>No records to display</p>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditOffsetForm({
  isOpen,
  onClose,
  user,
  employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
  employeePersonalInformationId, setEmployeePersonalInformationId,
  referenceDate, setReferenceDate,
  date, setDate,
  hours, setHours,
  type, setType,
  referenceId, setReferenceId,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  days, setDays,
  reason, setReason,
  files, setFiles,
  handleUpdate,
  viewImage,
}) {
  const [reference, setReference] = useState(null);
  const [showReferenceForm, setShowReferenceForm] = useState(false);
  const openReferenceForm = () => {
    setShowReferenceForm(true);
  };
  const closeReferenceForm = () => {
    setShowReferenceForm(false);
  };
  const [showReferenceDateForm, setShowReferenceDateForm] = useState(false);
  const openReferenceDateForm = () => {
    setShowReferenceDateForm(true);
  };
  const closeReferenceDateForm = () => {
    setShowReferenceDateForm(false);
  };

  const handleClose = () => {
    onClose();
    closeReferenceForm()
    closeReferenceDateForm()
    setReference(null)
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Type</div>
                <div className="info-item-input">
                  <TypeSelect data={type} setData={setType} isView={false}/>
                </div>
              </div>
              {type === "Overtime" &&
              <>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reference Date</div>
                  <div className="info-item-input">
                    <div
                      className="info-item-holder employee-select row"
                      style={{
                        flexDirection: "row",
                        justifyContent: "normal",
                      }}
                    >
                      <input
                        readOnly
                        className="employeeInput-select"
                        placeholder="Reference"
                        value={referenceDate ? referenceDate.split("T")[0] : ""}
                      />
                      <button
                        className="select row"
                        onClick={openReferenceDateForm}
                      >
                        <SearchIcon />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date (To Use)</div>
                  <div className="info-item-input">
                    <DateTimeInput date={date} setDate={setDate} isView={false} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="hours"
                      placeholder="Hours"
                      value={hours}
                      onChange={(e) => setHours(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              </>}
              {type === "Leave" &&
              <>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reference</div>
                  <div className="info-item-input">
                    <div
                      className="info-item-holder employee-select row"
                      style={{
                        flexDirection: "row",
                        justifyContent: "normal",
                      }}
                    >
                      <input
                        readOnly
                        className="employeeInput-select"
                        placeholder="Reference"
                        value={
                                referenceId
                                  ? `OS-${referenceId
                                      ?.toString()
                                      .padStart(6, "0")}`
                                  : ""}
                      />
                      <button
                        className="select row"
                        onClick={openReferenceForm}
                      >
                        <SearchIcon />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="days"
                      placeholder="Days"
                      value={days}
                      onChange={(e) => setDays(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From (To Use)</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateFrom} setDate={setDateFrom} isView={false} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To (To Use)</div>
                  <div className="info-item-input">
                    <DateTimeInput date={dateTo} setDate={setDateTo} isView={false} />
                  </div>
                </div>
              </div>
              </>}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <ReferenceSelectForm
        isOpen={showReferenceForm}
        onClose={closeReferenceForm}
        reference={reference} setReference={setReference}
        referenceId={referenceId} setReferenceId={setReferenceId}
        setDays={setDays}
        user={user}
      ></ReferenceSelectForm>
      <ReferenceDateSelectForm
        isOpen={showReferenceDateForm}
        onClose={closeReferenceDateForm}
        reference={referenceDate} setReference={setReferenceDate}
        setHours={setHours}
        user={user}
      ></ReferenceDateSelectForm>
    </>
  );
}

function ReferenceSelectForm({ isOpen, onClose, setReference, user, referenceId, setReferenceId, setDays}) {
  var header = [
    "Reference No.",
    "Employee",
    "Type",
    "Date From",
    "Date To",
    "Days",
    "Used",
    // "Remaining (Without Hold Value)",
    "Remaining",
  ];
  var accessor = [
    "leaveData.referenceNumber",
    "employeePersonalInformationFullName",
    "leaveData.leaveTypeDescription",
    "leaveData.dateFrom",
    "leaveData.dateTo",
    "leaveData.days",
    "useValue",
    // "remainingValueWithoutHoldValue",
    "remainingValue",
  ];

  const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    if (selectedReference.length !== 0) {
      setReference(selectedReference);
      console.log("selectedReference", selectedReference)
      setReferenceId(selectedReference.leaveData?.id);
      setDays(selectedReference.leaveData?.days);
    }
    fetchData();
  };

  const fetchData = useCallback(async () => {
    const apiUrl = `${domain}/api/OffsetLeave/employee/${user.employeePersonalInformationId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setData(response.data);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  }, [user]);

  useEffect(() => {
    if(isOpen){
      fetchData();
    }
  }, [isOpen, fetchData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={data?.data ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {data?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ReferenceDateSelectForm({ isOpen, onClose, setReference, setHours, user }) {
  var header = [
    "Date",
    // "Remaining (Without Hold Value)",
    "Remaining",
  ];
  var accessor = [
    "date",
    // "remainingValueWithoutHoldValue",
    "remainingValue",
  ];

  const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    if (selectedReference.length !== 0) {
      setReference(selectedReference?.date);
      setHours(selectedReference.remainingValueWithoutHoldValue);
    }
    fetchData();
  };

  const fetchData = useCallback(async () => {
    const apiUrl = `${domain}/api/OffsetOvertime/employee/${user.employeePersonalInformationId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setData(response.data);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  }, [user]);

  useEffect(() => {
    if(isOpen){
      fetchData();
    }
  }, [isOpen, fetchData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Date</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={data?.data ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {data?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function TypeSelect({ data, setData, isView }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setData(event.target.value);
  };

  useEffect(() => {
    if (data !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [data]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={data}
        onChange={handleSelectChange}
        disabled={isView}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose type
        </option>
        <option value="Overtime">Overtime</option>
        <option value="Leave">Leave</option>
      </select>
    </div>
  );
}
function OvertimeTypeSelect(overtimeType, setOvertimeType, isView) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setOvertimeType(event.target.value);
  };

  useEffect(() => {
    if (overtimeType !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [overtimeType]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={isView}
        value={overtimeType}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose overtime type
        </option>
        <option value="Regular">Regular</option>
        <option value="MainOfficeSaturday">Main Office Saturday</option>
        <option value="RestdaySaturday">Restday Saturday</option>
        <option value="RestdaySunday">Restday Sunday</option>
        <option value="SpecialHoliday">Special Holiday</option>
        <option value="RegularHoliday">Regular Holiday</option>
        <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
        <option value="RestdayRegularHoliday">Restday Regular Holiday</option>
      </select>
    </div>
  );
}
function LeaveTypeSelect(leaveType, setLeaveType, isView) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLeaveType(event.target.value);
  };

  const [leaveTypes, setLeaveTypes] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/LeaveType";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setLeaveTypes(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (leaveType !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [leaveType]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={isView}
        value={leaveType}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose leave type
        </option>
        {leaveTypes.map((leaveType) => SetLeaveType(leaveType))}
      </select>
    </div>
  );
}
function SetLeaveType(leaveType) {
  return (
    <option id={"leaveType" + leaveType.id} value={leaveType.id}>
      {leaveType.id + " - " + leaveType.description}
    </option>
  );
}
function DateTimeInput({date, setDate, isView}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  return (
    <div>
      <input
        readOnly={isView}
        type="datetime-local"
        name="datetime"
        value={date?.slice(0, 16)} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function DateInput(date, setDate, isView) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  let formattedDate = "";

  if (date) {
    formattedDate = date.split("T")[0];
  }

  return (
    <div>
      <input
        readOnly={isView}
        type="date"
        id={"datetime-"}
        name="datetime"
        value={formattedDate} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isView) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setShiftScheduleId(event.target.value);
  };

  const [shiftScheduleIds, setShiftScheduleIds] = useState([]);

  const apiUrl = domain + "/api/ShiftSchedule";

  const fetchData = useCallback(async () => {
    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setShiftScheduleIds(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [apiUrl]);

  useEffect(() => {
    fetchData();

    if (shiftScheduleId !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, shiftScheduleId]);

  return (
    <div>
      <select
        id="overtime-employee-name"
        disabled={isView}
        value={shiftScheduleId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose shift schedule
        </option>
        {shiftScheduleIds.map((shiftScheduleId) =>
          SetShiftScheduleId(shiftScheduleId)
        )}
      </select>
    </div>
  );
}
function SetShiftScheduleId(shiftScheduleId) {
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  };

  return (
    <option
      id={"overtimeAdd" + shiftScheduleId.id}
      value={shiftScheduleId.id}
    >{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(
      shiftScheduleId.timeFrom
    )} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
  );
}
function TimeInput({ date, setDate, isView }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    setIsSelected(date !== undefined && date !== "");
  }, [date]);

  return (
    <div>
      <input
        readOnly={isView}
        type="datetime-local"
        id="datetime-input"
        name="datetime"
        value={date}
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}

function TimeTypeSelect({ timeType, setTimeType }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setTimeType(event.target.value);
  };

  useEffect(() => {
    if (timeType) {
      setIsSelected(true);
    }
  }, [timeType]);

  return (
    <div>
      <select
        id="timeType"
        value={timeType || ""}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose Time Type
        </option>
        <option value="In">Time-In</option>
        <option value="Out">Time-Out</option>
        <option value="NoIn">No-In</option>
        <option value="NoOut">No-Out</option>
      </select>
    </div>
  );
}
const CustomTooltip = ({ active, payload }) => {
  if (!active || !tooltip) return null;
  for (const bar of payload)
    if (bar.dataKey === tooltip)
      return (
        <div className="tooltipCustom">
          {bar.name}
          <br />
          {bar.value.toFixed(2)}
        </div>
      );
  return null;
};
const TypingAnimation = ({ wordings }) => {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const words = wordings;
  const typingSpeed = 50; // Adjust typing speed here
  const repeatInterval = 5000; // Repeat every x seconds

  useEffect(() => {
    let typingInterval;

    if (index < words.length) {
      typingInterval = setInterval(() => {
        setText(words.slice(0, index + 1));
        setIndex(index + 1);
      }, typingSpeed);
    } else {
      setTimeout(() => {
        setText("");
        setIndex(0);
      }, repeatInterval);
    }

    return () => clearInterval(typingInterval);
  }, [index, words, typingSpeed, repeatInterval]);

  return (
    <div className="text-customMainColor">
      <span>{text}</span>
    </div>
  );
};
function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
  editHandleClick,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export function CreateTableForReferenceSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  setSelectedReference,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    viewHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            style={{ textAlign: "center" }}
          >{`${currentPage}/${totalPages}`}</div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo(header, _cell, editHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (header === "Photo") {
      if (data.photo) {
        const imageSrc = "data:image/jpeg;base64," + data.photo;

        return (
          <td>
            <img className="avatarImg" src={imageSrc} alt="" />
          </td>
        );
      }
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    }

    if (value === "" || value === null || value === undefined) {
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    } else {
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    }
  }
  
  if (header === "Request Date") {
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (header === "Days" ||
    header === "Used" ||
    header === "On Hold" ||
    header === "Remaining" ||
    header === "Remaining (Without Hold Value)"
  ) {
    const value = _cell.render("Cell").props.value;

    if (!value) {
      return <td>0.00</td>;
    }

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <TooltipManage text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <RemoveRedEyeIcon />
            </div>
          </TooltipManage>
        </div>
      </td>
    );
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function CreateTableTransaction({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  editHandleClick,
  deleteHandleClick,
  viewImage,
  approvals,
  hierarchy,
  listOfEmployees,
  overtimeRequestData,
  leaveRequestData,
  changeOfScheduleData,
  changeLogRequestData,

  currentPage,
  setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <SetInfoTransaction
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                    viewHandleClick={viewHandleClick}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    viewImage={viewImage}
                    approvals={approvals}
                    hierarchy={hierarchy}
                    listOfEmployees={listOfEmployees}
                    dataList={dataList}
                    overtimeRequestData={overtimeRequestData}
                    leaveRequestData={leaveRequestData}
                    changeOfScheduleData={changeOfScheduleData}
                    changeLogRequestData={changeLogRequestData}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfoTransaction({
  header,
  _cell,
  viewHandleClick,
  editHandleClick,
  deleteHandleClick,
  viewImage,
  approvals,
  hierarchy,
  listOfEmployees,
  dataList,
  overtimeRequestData,
  leaveRequestData,
  changeOfScheduleData,
  changeLogRequestData,
}) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (header === "Photo") {
      if (data.photo) {
        const imageSrc = "data:image/jpeg;base64," + data.photo;

        return (
          <td>
            <img className="avatarImg" src={imageSrc} alt="" />
          </td>
        );
      }
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    }

    if (value === "" || value === null || value === undefined) {
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    } else {
      return (
        <td>
          <img className="avatarImg" src="images/sample.jpg" alt="" />
        </td>
      );
    }
  }

  if (header === "Track Approvers") {
    const trackApproval = data.approval;

    if (!trackApproval) {
      return (
        <td>
          <>
            {`Primary Approver: Pending`}
            <br />
            <br />
            {`Secondary Approver: Pending`}
            <br />
            <br />
            {`Tertiary Approver: Pending`}
            <br />
            <br />
          </>
        </td>
      );
    }

    return (
      <td>
        <>
          {trackApproval.primaryApproverId !== undefined && (
            <>
              <span>{`Primary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.primaryApproverStatus}
              >{`${
                trackApproval.primaryApproverStatus !== ""
                  ? trackApproval.primaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.primaryApproverStatus === "Approved" ||
                trackApproval.primaryApproverStatus === "Disapproved") &&
                trackApproval.primaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.primaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
          {trackApproval.secondaryApproverId !== undefined && (
            <>
              <span>{`Secondary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.secondaryApproverStatus}
              >{`${
                trackApproval.secondaryApproverStatus !== ""
                  ? trackApproval.secondaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.secondaryApproverStatus === "Approved" ||
                trackApproval.secondaryApproverStatus === "Disapproved") &&
                trackApproval.secondaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.secondaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
          {trackApproval.tertiaryApproverId !== undefined && (
            <>
              <span>{`Tertiary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.tertiaryApproverStatus}
              >{`${
                trackApproval.tertiaryApproverStatus !== ""
                  ? trackApproval.tertiaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.tertiaryApproverStatus === "Approved" ||
                trackApproval.tertiaryApproverStatus === "Disapproved") &&
                trackApproval.tertiaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.tertiaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
        </>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.requestTypeId === 1) {
      //Leave
      if (leaveRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = leaveRequestData.find((_data) => _data.id === data.id);
      if (foundData.content) {
        return (
          <td>
            <div
              className="emp-transac-manage row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <TooltipManage text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </TooltipManage>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 2) {
      //Change Schedule
      if (changeOfScheduleData.length <= 0) {
        return <td></td>;
      }
      const foundData = changeOfScheduleData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="emp-transac-manage row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <TooltipManage text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </TooltipManage>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 3) {
      //OT
      if (overtimeRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = overtimeRequestData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="emp-transac-manage row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <TooltipManage text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </TooltipManage>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 4) {
      // Change Log
      if (changeLogRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = changeLogRequestData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="emp-transac-manage row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <TooltipManage text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </TooltipManage>
            </div>
          </td>
        );
      }
      return <td></td>;
    }
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Type") {
    const foundData = dataList.find(
      (dataInfo) =>
        dataInfo.requestTypeId === data.requestTypeId && dataInfo.id === data.id
    );

    if (foundData.requestTypeId === 1) {
      // Leave
      if (leaveRequestData.length <= 0) {
        return <td></td>;
      }
      const foundDataLeave = leaveRequestData.find(
        (request) => request.id === foundData.id
      );
      return <td>{foundDataLeave.leaveTypeDescription}</td>;
    } else if (foundData.requestTypeId === 2) {
      // Change Schedule
      return <td>{"-"}</td>;
    } else if (foundData.requestTypeId === 3) {
      // OT
      if (overtimeRequestData.length <= 0) {
        return <td></td>;
      }
      const foundDataOT = overtimeRequestData.find(
        (request) => request.id === foundData.id
      );
      return <td>{foundDataOT.overtimeType}</td>;
    } else if (foundData.requestTypeId === 4) {
      // Change Log
      if (changeLogRequestData.length <= 0) {
        return <td></td>;
      }
      const foundDataChangeLog = changeLogRequestData.find(
        (request) => request.id === foundData.id
      );
      return <td>{`Time - ${foundDataChangeLog.timeType}`}</td>;
    }
  }

  if (header === "Status") {
    let convertedValue = value;

    if (convertedValue === "Sent") {
      convertedValue = "Pending";
    }
    return <td className={convertedValue}>{convertedValue}</td>;
  }

  if (
    header === "Time In" ||
    header === "Time Out" ||
    header === "Time Rendered"
  ) {
    const time = _cell.render("Cell").props.value;

    if (!time) {
      return <td>-</td>;
    }

    let formattedTime = "";

    // Attempt to parse the time if it’s not already in ISO format
    let date;
    if (time.includes("T")) {
      date = new Date(time);
    } else {
      // If the time is not in ISO format, manually create the date
      const currentDate = new Date(); // Get current date for the date portion
      const [hours, minutes] = time
        .split(":")
        .map((part) => parseInt(part, 10));

      if (isNaN(hours) || isNaN(minutes)) {
        return <td>Invalid time format</td>;
      }

      date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        hours,
        minutes
      );
    }

    if (isNaN(date.getTime())) {
      return <td>Invalid time format</td>;
    }

    // Convert to desired format YYYY-MM-DDTHH:mm
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    // const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    // console.log(formattedDateTime); // Logs the converted time for debugging

    // Further formatting based on globalTimeFormat
    if (globalTimeFormat === "Standard Time") {
      const amPm = date.getHours() >= 12 ? "PM" : "AM";
      const standardHours = date.getHours() % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${standardHours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  if (header === "Date" || header === "Date From" || header === "Date To") {
    let _value = value;

    if (header === "Date" && data.otDate) {
      _value = data.otDate;
    }

    if (header === "Date" && data.offsetOTDate) {
      _value = data.offsetOTDate;
    }

    if (header === "Date" && data.changeLogDate) {
      _value = data.changeLogDate;
    }

    if (header === "Date From" && data.leaveDateFrom) {
      _value = data.leaveDateFrom;
    }

    if (header === "Date To" && data.leaveDateTo) {
      _value = data.leaveDateTo;
    }

    if (header === "Date From" && data.changeScheduleDateFrom) {
      _value = data.changeScheduleDateFrom;
    }

    if (header === "Date To" && data.changeScheduleDateTo) {
      _value = data.changeScheduleDateTo;
    }

    if (header === "Date From" && data.offsetLeaveDateFrom) {
      _value = data.offsetLeaveDateFrom;
    }

    if (header === "Date To" && data.offsetLeaveDateTo) {
      _value = data.offsetLeaveDateTo;
    }

    if (!_value) {
      return <td>-</td>;
    }

    const date = new Date(_value);

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (header === "Date Processed" || header === "Request Date") {
    const date = new Date(_cell.render("Cell").props.value);

    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (header === "") {
    const allowedStatuses = ["Pending", "Sent", null];

    const approvers = [
      {
        id: data.approval?.primaryApproverId,
        status: data.approval?.primaryApproverStatus,
      },
      {
        id: data.approval?.secondaryApproverId,
        status: data.approval?.secondaryApproverStatus,
      },
      {
        id: data.approval?.tertiaryApproverId,
        status: data.approval?.tertiaryApproverStatus,
      },
    ];

    const availableApprovers = approvers.filter(
      (approver) => approver.id != null
    );

    const canEdit = availableApprovers.every((approver) =>
      allowedStatuses.includes(approver.status)
    );

    console.log({data}, {canEdit})

    return (
      <td>
        <div
          className="emp-transac-manage row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          {canEdit && (
            <>
              <TooltipManage text="Update">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => editHandleClick(data)}
                >
                  <EditIcon />
                </div>
              </TooltipManage>

              <TooltipManage text="Cancel">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => deleteHandleClick(data)}
                >
                  <NotInterestedIcon />
                </div>
              </TooltipManage>
            </>
          )}
          <TooltipManage text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => viewHandleClick(data)}
            >
              <RemoveRedEyeIcon />
            </div>
          </TooltipManage>
        </div>
      </td>
    );
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function CreateTableItinerary({
  dataList = [],
  setDataList,
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
  isItinerayAddState,
  setIsItinerayAddState,
  isItinerayUpdateState,
  setIsItinerayUpdateState,
  isItinerayDeleteState,
  setIsItinerayDeleteState,
  itineraryTimeIn,
  setItineraryTimeIn,
  itineraryTimeOut,
  setItineraryTimeOut,
  itineraryLocation,
  setItineraryLocation,
  openItinerary,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [idCounter, setIdCounter] = useState(0);
  const [recoveredData, setRecoveredData] = useState([]);

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const newData = {
    changeLogRequestId: idCounter + 1,
    timeIn: itineraryTimeIn,
    timeOut: itineraryTimeOut,
    location: itineraryLocation,
  };

  const saveAdd = () => {
    setIdCounter(idCounter + 1);
    setIsItinerayAddState(false);
    setIsItinerayUpdateState(false);
    setDataList((prevDataList) => [...prevDataList, newData]);

    setItineraryTimeIn("");
    setItineraryTimeOut("");
    setItineraryLocation("");
  };

  const cancelAdd = () => {
    setIsItinerayAddState(false);

    setItineraryTimeIn("");
    setItineraryTimeOut("");
    setItineraryLocation("");
  };

  const updateClick = (data) => {
    setRecoveredData(data);
    setItineraryTimeIn(data.timeIn);
    setItineraryTimeOut(data.timeOut);
    setItineraryLocation(data.location);
    const foundData = dataList.find(
      (_data) => _data.changeLogRequestId === data.changeLogRequestId
    );

    setDataList((prevDataList) =>
      prevDataList.filter(
        (_data) => _data.changeLogRequestId !== foundData.changeLogRequestId
      )
    );

    setIsItinerayUpdateState(true);
  };
  const cancelUpdate = () => {
    setIdCounter(idCounter + 1);

    const oldData = {
      changeLogRequestId: recoveredData.changeLogRequestId,
      timeIn: recoveredData.timeIn,
      timeOut: recoveredData.timeOut,
      location: recoveredData.location,
    };

    setDataList((prevDataList) => [...prevDataList, oldData]);

    setItineraryTimeIn("");
    setItineraryTimeOut("");
    setItineraryLocation("");

    setIsItinerayUpdateState(false);
  };
  const deleteClick = (data) => {
    const foundData = dataList.find(
      (_data) => _data.changeLogRequestId === data.changeLogRequestId
    );

    setDataList((prevDataList) =>
      prevDataList.filter(
        (_data) => _data.changeLogRequestId !== foundData.changeLogRequestId
      )
    );
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {isItinerayAddState && (
            <tr>
              <td>
                <TimeInput
                  date={itineraryTimeIn}
                  setDate={setItineraryTimeIn}
                />
              </td>
              <td>
                <TimeInput
                  date={itineraryTimeOut}
                  setDate={setItineraryTimeOut}
                />
              </td>
              <td>
                <input
                  placeholder="Enter location"
                  value={itineraryLocation}
                  onChange={(e) => setItineraryLocation(e.target.value)}
                  style={{
                    color: "gray",
                    height: "30px",
                    borderRadius: "3px",
                    border: "1px solid #80808080",
                    outline: "none",
                    width: "90%",
                  }}
                />
              </td>
              <td>
                <div
                  className="row itinerary-manage"
                  style={{ alignItems: "center", justifyContent: "center" }}
                >
                  <TooltipManage text="Save">
                    <div style={{ padding: "0 5px" }} onClick={saveAdd}>
                      <SaveIcon />
                    </div>
                  </TooltipManage>
                  <TooltipManage text="Cancel">
                    <div style={{ padding: "0 5px" }} onClick={cancelAdd}>
                      <DoDisturbIcon />
                    </div>
                  </TooltipManage>
                </div>
              </td>
            </tr>
          )}
          {isItinerayUpdateState && (
            <tr>
              <td>
                <TimeInput
                  date={itineraryTimeIn}
                  setDate={setItineraryTimeIn}
                />
              </td>
              <td>
                <TimeInput
                  date={itineraryTimeOut}
                  setDate={setItineraryTimeOut}
                />
              </td>
              <td>
                <input
                  placeholder="Enter location"
                  value={itineraryLocation}
                  onChange={(e) => setItineraryLocation(e.target.value)}
                  style={{
                    color: "gray",
                    height: "30px",
                    borderRadius: "3px",
                    border: "1px solid #80808080",
                    outline: "none",
                    width: "90%",
                  }}
                />
              </td>
              <td>
                <div
                  className="row itinerary-manage"
                  style={{ alignItems: "center", justifyContent: "center" }}
                >
                  <TooltipManage text="Save">
                    <div style={{ padding: "0 5px" }} onClick={saveAdd}>
                      <SaveIcon />
                    </div>
                  </TooltipManage>
                  <TooltipManage text="Cancel">
                    <div style={{ padding: "0 5px" }} onClick={cancelUpdate}>
                      <DoDisturbIcon />
                    </div>
                  </TooltipManage>
                </div>
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfoItinerary(
                    cell.render("Cell").props.column.Header,
                    cell,
                    updateClick,
                    deleteClick,
                    openItinerary
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfoItinerary(
  header,
  _cell,
  editHandleClick,
  deleteHandleClick,
  openItinerary
) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div
          className="itinerary row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <TooltipManage text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </TooltipManage>
          {deleteHandleClick ? (
            <TooltipManage text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </TooltipManage>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Itinerary") {
    return (
      <td>
        <div
          className="itineary-control row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <TooltipManage text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => openItinerary(data)}
            >
              <ListIcon />
            </div>
          </TooltipManage>
        </div>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (
    header === "Time In" ||
    header === "Time Out" ||
    header === "Time Rendered"
  ) {
    const time = _cell.render("Cell").props.value;

    if (!time) {
      return <td>-</td>;
    }

    let formattedTime = "";

    // Attempt to parse the time if it’s not already in ISO format
    let date;
    if (time.includes("T")) {
      date = new Date(time);
    } else {
      // If the time is not in ISO format, manually create the date
      const currentDate = new Date(); // Get current date for the date portion
      const [hours, minutes] = time
        .split(":")
        .map((part) => parseInt(part, 10));

      if (isNaN(hours) || isNaN(minutes)) {
        return <td>Invalid time format</td>;
      }

      date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        hours,
        minutes
      );
    }

    if (isNaN(date.getTime())) {
      return <td>Invalid time format</td>;
    }

    // Convert to desired format YYYY-MM-DDTHH:mm
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    // const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    // console.log(formattedDateTime); // Logs the converted time for debugging

    // Further formatting based on globalTimeFormat
    if (globalTimeFormat === "Standard Time") {
      const amPm = date.getHours() >= 12 ? "PM" : "AM";
      const standardHours = date.getHours() % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${standardHours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }
  
  if (header === "Request Date") {
    const value = _cell.render("Cell").props.value;
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function Filter(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      <option value="All">All</option>
      <option value="EmployeeId">Employee Id</option>
    </select>
  );
}
function Sort(filterDataIndex, setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setFilterDataIndex(event.target.value);
  };

  useEffect(() => {
    if (filterDataIndex !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [filterDataIndex]);

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
      style={{
        color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
      }}
    >
      <option value="" disabled hidden>{`Choose filter`}</option>
      <option value="Name (A to Z)">{`Name (A to Z)`}</option>
      <option value="Name (Z to A)">{`Name (Z to A)`}</option>
      <option value="Employee Id (lowest to highest)">
        {`Employee Id (lowest to highest)`}{" "}
      </option>
      <option value="Employee Id (highest to lowest)">{`Employee Id (highest to lowest)`}</option>
    </select>
  );
}
function ClassificationFilterDummy() {
  return (
    <select
      id="employee-select-PagibigReport"
      value={""}
      disabled
      style={{ color: "rgb(104, 104, 104)" }}
    ></select>
  );
}
function ClassificationFilter1({ classificationId, setClassificationId }) {
  const handleSelectChange = (event) => {
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Classification/active";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers if needed
        },
      });

      setData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <select
      id="employee-select-PagibigReport"
      value={classificationId}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      <option value={"0"}>All</option>
      {data.map((classificationId) => SetClassificationId(classificationId))}
    </select>
  );
}
function ClassificationFilter2({ classificationId, setClassificationId }) {
  const handleSelectChange = (event) => {
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Classification/active";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers if needed
        },
      });

      setData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <select
      id="employee-select-PagibigReport"
      value={classificationId}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      {data.map((classificationId) => (
        <React.Fragment key={classificationId.id}>
          {classificationId.id === 2 && SetClassificationId(classificationId)}
          {classificationId.id === 3 && SetClassificationId(classificationId)}
          {classificationId.id === 4 && SetClassificationId(classificationId)}
        </React.Fragment>
      ))}
    </select>
  );
}
function ClassificationFilter3({ classificationId, setClassificationId }) {
  const handleSelectChange = (event) => {
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Classification/active";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers if needed
        },
      });

      setData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <select
      id="employee-select-PagibigReport"
      value={classificationId}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      {data.map((classificationId) => (
        <React.Fragment key={classificationId.id}>
          {classificationId.id === 4 && SetClassificationId(classificationId)}
        </React.Fragment>
      ))}
    </select>
  );
}
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{classificationId.description}</option>
  );
}
function SectionIdSelect({ sectionId, setSectionId }) {
  const handleSelectChange = (event) => {
    setSectionId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Section/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={sectionId}
        onChange={handleSelectChange}
        style={{ color: "rgb(104, 104, 104)" }}
      >
        <option value="0">All</option>
        {data.map((sectionId) => SetSectionId(sectionId))}
      </select>
    </div>
  );
}
function SetSectionId(sectionId) {
  return <option value={sectionId.id}>{sectionId.description}</option>;
}
const TooltipManage = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function ClearGeneralForm({ isOpen, onClose, handleDelete }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Cancel!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to cancel this request?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => {
                  handleDelete(e);
                  handleClose();
                }}
                style={{ marginRight: "5px" }}
              >
                YES
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                NO
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewImage({ isOpen, onClose, viewImageData }) {
  const [imageSource, setImageSource] = useState("");

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (isOpen && viewImageData.content instanceof File) {
      const reader = new FileReader();

      reader.onloadend = () => {
        // Once the file is read, set the image source to the base64 data
        setImageSource(reader.result);
      };

      // Read the file as a Data URL (which includes the base64 encoding)
      reader.readAsDataURL(viewImageData.content);
    }
  }, [isOpen, viewImageData]);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const openImage = () => {
    setIsImageModalOpen(true); // Open image in full view
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close full image modal
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Uploaded Image</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  className="modal-events-image"
                  src={imageSource}
                  alt=""
                  style={{ width: "250px", height: "auto" }}
                  onClick={openImage}
                />
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Full Image Modal */}
      {isImageModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal} // Click outside to close
        >
          <img
            src={imageSource}
            alt="Full view"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
}
function AnnouncementModal({ isOpen, onClose, content, image }) {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (image) {
        const src = await convertImage(image);
        setImageSrc(src);
      }
    };

    fetchImage();
  }, [image]);

  const convertImage = async (crpytImage) => {
    if (crpytImage) {
      const imageSrc = "data:image/jpeg;base64," + crpytImage;
      return imageSrc;
    }
    return null;
  };

  const handleClose = () => {
    onClose();
  };

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const openImage = () => {
    setIsImageModalOpen(true); // Open image in full view
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close full image modal
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Announcement</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div
                dangerouslySetInnerHTML={{
                  __html: content.replace(/\n/g, "<br />"),
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "20px 0",
                }}
              >
                {imageSrc && (
                  <img
                    className="modal-events-image"
                    src={imageSrc}
                    alt=""
                    style={{ width: "250px", height: "auto" }}
                    onClick={openImage}
                  />
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Full Image Modal */}
      {isImageModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal} // Click outside to close
        >
          <img
            src={imageSrc}
            alt="Full view"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
}
function MemoModal({ isOpen, onClose, content, image }) {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (image) {
        const src = await convertImage(image);
        setImageSrc(src);
      }
    };

    fetchImage();
  }, [image]);

  const convertImage = async (crpytImage) => {
    if (crpytImage) {
      const imageSrc = "data:image/jpeg;base64," + crpytImage;
      return imageSrc;
    }
    return null;
  };

  const handleClose = () => {
    onClose();
  };

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const openImage = () => {
    setIsImageModalOpen(true); // Open image in full view
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close full image modal
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Memo</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div
                dangerouslySetInnerHTML={{
                  __html: content.replace(/\n/g, "<br />"),
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "20px 0",
                }}
              >
                {imageSrc && (
                  <img
                    className="modal-events-image"
                    src={imageSrc}
                    alt=""
                    style={{ width: "250px", height: "auto" }}
                    onClick={openImage}
                  />
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Full Image Modal */}
      {isImageModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal} // Click outside to close
        >
          <img
            src={imageSrc}
            alt="Full view"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
}
function LocationIdSelect({ locationId, setLocationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Location/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (locationId !== "" && locationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [locationId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={locationId}
        onChange={handleSelectChange}
        style={{
          height: "30px",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="0">All</option>
        {data.map((locationId) => SetLocationId(locationId))}
      </select>
    </div>
  );
}
function SetLocationId(locationId) {
  return <option value={locationId.id}>{locationId.description}</option>;
}
export default Home;
